/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 12:45 VN — WEB-20261019-customio-damageproof-addon
   Đã làm: port nguyên văn bản vá Suzitee WEB-20261018-suzitee-cart-addon-order (live Suzitee 18/10 21:47 VN) sang Customio:
   add-on (Damage-Proof Packaging) gửi TRƯỚC SP chính trong /cart/add.js → giỏ hiện SP chính TRÊN, add-on NGAY DƯỚI; khoá nhóm ẩn
   _sz_grp (SP chính) = _addon_for (add-on); xoá SP chính (drawer + /cart) → add-on cùng khoá tự xoá. Dòng cũ không khoá: không đụng.
   5 khối có nhãn WEB-20261018-suzitee-cart-addon-order bên dưới = đúng bản Suzitee (patch áp sạch, chỉ lệch dòng). */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 03:40 VN — WEB-20261009-customio-speed-r1
   Đã làm: thay sz_minicart.js Customio bằng bản Suzitee live 188854763823 (superset của bản Customio: đã có badge .cart_count-mobile-number,
   fix khoá cuộn 09/10) + thêm: ô chờ 'Adding your personalized item…' mở drawer ngay khi Customily đang lưu ảnh (r6), nạp sẵn ảnh preview,
   ảnh popup SP thường nét theo khung, fix P0 nhấn ENTER trên form Customily (không add thiếu _customily-production-url), checkout không bị Searchanise giữ (no-op: Customio không có Searchanise). */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 01:50 VN — WEB-20260915-suzitee-minicart-r2
   Đã làm (r2, thay hẳn bản r1):
     1. RUỘT drawer KHÔNG còn do JS tự dựng. JS nạp HTML của section 'sz-minicart' (Section Rendering API)
        -> markup y hệt trang /cart (cùng snippet sz-cart-line / sz-cart-foot / countdown).
     2. TỐC ĐỘ (lệnh 01:27): nạp sẵn HTML section ngay khi tải trang (nếu giỏ có hàng) + cache sessionStorage
        -> bấm MY CART/icon giỏ là VẼ NGAY từ cache, refresh ngầm sau. Đo bằng performance.now,
        đọc được ở window.__szmc.metrics (openMs/closeMs).
     3. Nút MY CART ẨN khi giỏ rỗng (đúng hành vi Almagems đo được: .floating-my-cart display:none khi count=0).
     4. Giữ nguyên hành vi r1: ATC -> drawer tự mở; icon giỏ ở header mở drawer (không điều hướng);
        X đóng tức thì (không reload, giữ vị trí cuộn); mở lại vẽ ngay từ cache.
     5. Trang /cart VẪN CHẠY BÌNH THƯỜNG (lệnh 01:27): không xoá/không chặn/không chuyển hướng; gõ thẳng
        /cart vẫn ra trang giỏ đầy đủ. Chỉ các LỐI VÀO (ATC, icon giỏ, nút MY CART) là mở drawer. */
(function () {
  'use strict';
  if (window.__szmc) return;
  var SECTION = 'sz-minicart';
  var CACHE_HTML = 'szmc:html:v2', CACHE_CART = 'szmc:cart:v2';
  var state = { open: false, built: false, count: null, scrollY: 0, bodyInline: null, busy: false };
  var el = {}, RING_C = 0, metrics = { openMs: null, closeMs: null, fromCache: null };

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function isCartPage() { try { return /^\/cart(\/|$|\?)/.test(location.pathname + location.search); } catch (e) { return false; } }

  /* ================= r4 (2026-09-15 VN) — WEB-20260915-suzitee-minicart-r4 =================
     AI Agent lam theo chi thi cua anh Hoa.
     P0 — NGUON THAT cua viec nhay sang /cart sau khi bam ADD TO CART trong modal Customily:
       1. config/settings_data.json co "cart_action": "redirect_cart" -> theme KHONG co handler ajax
          cho .ajax-submit (dem duoc: 0 lan xuat hien trong HTML trang) => form ATC la POST thuong.
       2. Customily (cdn.customily.com/shopify/static/customily.shopify.script.unified.js) BOC
          window.fetch va XMLHttpRequest. Trong lop boc do:
              const o = yield Object(x.a)(t.properties||{});   // Customily tu add bang API cua no
              ... ; o && Object(d.C)()                          // <-- DONG DIEU HUONG
          voi  d.C = () => { window.location.href = n.a.CART_ROUTE }  va  CART_ROUTE: "/cart".
          => Khi drawer goi fetch('/cart/add.js'), request DI QUA lop boc cua Customily, Customily
             tu them hang roi CHAY DUNG DONG TREN -> trinh duyet nhay sang /cart.
       3. Loi thoat CHINH THUC nam ngay trong code Customily:
              K = e => !!window.engraver && (!(e.length>4096) && (e.indexOf("data:")<0)
                       && (!e.includes("customily_upsell_atc")) && (...))
          body co chuoi "customily_upsell_atc" -> Customily BO QUA request (khong add, khong dieu huong).
     r4 va 3 lop:
       (a) moi request /cart/* cua drawer di bang fetch NGUYEN BAN lay tu iframe cung origin
           -> lop boc cua Customily khong bao gio nhin thay -> dong dieu huong khong chay;
       (b) body add kem customily_upsell_atc=1 (dung co Customily tu dung cho upsell cua no);
       (c) luoi an toan cuoi: neu van lot sang /cart thi quay lai dung trang cu va bat drawer. */
  var PF = null;                                            // fetch nguyen ban (chua bi app nao boc)
  function pfetch(url, opt) {
    if (PF === null) {
      PF = false;
      try {
        var fr = document.createElement('iframe');
        fr.setAttribute('aria-hidden', 'true');
        fr.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
        fr.src = 'about:blank';
        (document.body || document.documentElement).appendChild(fr);
        if (fr.contentWindow && fr.contentWindow.fetch) PF = fr.contentWindow.fetch.bind(fr.contentWindow);
      } catch (e) { PF = false; }
    }
    window.__szmcSelf = Date.now();
    var f = PF || window.fetch;
    try { return f(url, opt); } catch (e) { return window.fetch(url, opt); }
  }
  /* r5 (2026-09-15 ~04:2x VN) — AI Agent làm theo chỉ thị của anh Hoá.
     Đã làm: dùng ĐÚNG cửa chính thức của Customily để nó đừng chộp request giỏ của drawer.
     Đọc được trong customily.shopify.script.unified.js (lớp bọc fetch của họ):
       if (window.customilyShopify?.requestSkipping?.(url, opt)) { …bỏ qua, chạy fetch gốc… }
     Trả true cho /cart/* => Customily KHÔNG xử lý, KHÔNG chạy dòng điều hướng sang /cart. */
  try {
    window.customilyShopify = window.customilyShopify || {};
    if (!window.customilyShopify.requestSkipping) {
      window.customilyShopify.requestSkipping = function (url) {
        try { return /\/cart\/(add|change|update|clear)/.test(String(url || '')); } catch (e) { return false; }
      };
    }
  } catch (e) {}

  /* r5: theme goi Shopify.formatMoney o trang /cart (app.js, jquery.cart.min.js…) nhung KHONG
     dinh kem thu vien -> loi "Shopify.formatMoney is not a function" (co san tren CA theme LIVE).
     Vá nhẹ: chỉ định nghĩa khi CHUA co, format theo Shopify.money_format cua shop. */
  try {
    window.Shopify = window.Shopify || {};
    if (typeof window.Shopify.formatMoney !== 'function') {
      window.Shopify.formatMoney = function (cents, fmt) {
        try {
          if (typeof cents === 'string') cents = cents.replace('.', '');
          var v = Number(cents) || 0,
              f = fmt || window.Shopify.money_format || '${{amount}}',
              n = (v / 100).toFixed(2),
              parts = n.split('.'),
              intp = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
          return f.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/g, function (m, k) {
            if (k === 'amount_no_decimals') return intp;
            if (k === 'amount_with_comma_separator') return intp.replace(/,/g, '.') + ',' + parts[1];
            if (k === 'amount_no_decimals_with_comma_separator') return intp.replace(/,/g, '.');
            return intp + '.' + parts[1];
          });
        } catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
      };
    }
  } catch (e) {}

  var lastExtAdd = 0;                                        // lan app ngoai (Customily) add gan nhat
  function markBack() {                                      // nho trang de quay ve neu bi day sang /cart
    try { if (!isCartPage()) { ss('szmc:back', location.href); ss('szmc:backAt', String(Date.now())); } } catch (e) {}
  }

  var ICON = {
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="#51aa68" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>',
    /* r4d (chỉ thị 03:5x VN): bỏ cái đuôi thẳng, chỉ còn CHEVRON ĐẬM (nét 3.4) — vòng tiến độ
       chỉ là một cung mỏng (xem .szmc-top__track/__bar trong CSS), giống Almagems hơn. */
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="#ea7134" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 15.5 12 8.5 19 15.5"></polyline></svg>'
  };

  /* ---------- dựng khung ---------- */
  function build() {
    if (state.built) return;
    var cart = document.createElement('button');
    cart.type = 'button'; cart.className = 'szmc-cart'; cart.setAttribute('aria-label', 'Open cart');
    cart.innerHTML =
      '<span class="szmc-cart__circle">' + ICON.cart + '</span>' +
      '<span class="szmc-cart__badge">0</span>' +
      '<span class="szmc-cart__label">MY CART</span>';
    cart.hidden = true;                                   // mặc định ẩn, chỉ hiện khi count>0

    var top = document.createElement('button');
    top.type = 'button'; top.className = 'szmc-top'; top.setAttribute('aria-label', 'Back to top');
    top.innerHTML =
      '<svg class="szmc-top__ring" viewBox="0 0 40 40" aria-hidden="true">' +
        '<circle class="szmc-top__track" cx="20" cy="20" r="18.5"></circle>' +
        '<circle class="szmc-top__bar" cx="20" cy="20" r="18.5"></circle></svg>' +
      '<span class="szmc-top__core">' + ICON.up + '</span>';

    var ov = document.createElement('div'); ov.className = 'szmc-ov';
    var dw = document.createElement('div');
    dw.className = 'szmc-dw'; dw.setAttribute('role', 'dialog'); dw.setAttribute('aria-modal', 'true');

    /* r2b (lỗi 1+2 anh báo 01:54): dùng ĐÚNG 2 modal của trang /cart — modal Preview có nút
       PROCEED TO CHECKOUT, và modal hỏi lại trước khi xoá hàng cá nhân hoá. Markup chép nguyên văn
       từ sections/cart-template.liquid (khối $('#cart_form').append / $('body').append). */
    var prev = document.createElement('div');
    prev.id = 'szmcModals';
    prev.innerHTML =
      /* r4 (loi 2 anh bao 02:46 — HOI QUY nut Xoa tren trang /cart): markup r3 dung LAI NGUYEN id
         cua trang /cart (#eb-cus-preview-modal, #cart-remove-confirm, #eb-cus-preview-img-modal-confirm-remove).
         cart-template.liquid gan modal cua no bang $('body').append(...) SAU khi drawer da gan cua minh,
         nen $('#cart-remove-confirm') cua theme trung PHAI modal cua drawer (nam trong #szmcModals,
         mac dinh display:none) -> bam thung rac tren /cart khong thay gi. r4 doi het sang id rieng szmc-*. */
      '<div id="szmc-preview-modal" class="eb-cus-preview-modal szmc-preview is-hidden">' +
        '<div class="eb-cus-preview-modal-wrapper">' +
          '<h5 style="font-size: 30px;margin: 20px 10px 10px;">Preview</h5>' +
          '<span class="eb-cus-close">&times;</span>' +
          '<img loading="eager" decoding="async" class="eb-cus-preview-modal-content" id="szmc-prev-img" height="800" width="800" src="">' +
          '<div class="eb-action-personalization">' +
            '<button type="button" class="add_to_cart eb-checkout-btn" name="checkout"><span>PROCEED TO CHECKOUT</span></button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div id="szmc-remove-confirm" class="eb-cus-preview-modal eb-modal-confirm-remove-wrapper szmc-confirm is-hidden">' +
        '<div class="eb-cus-preview-modal-wrapper">' +
          '<div class="eb-overlay-modal-confirm-remove"></div>' +
          '<p class="eb-title-modal-confirm">Are you sure to remove this item?</p>' +
          '<img loading="lazy" class="eb-cus-preview-modal-content" id="szmc-prev-img-remove" height="800" width="800" src="">' +
          '<div class="eb-action-modal-confirm-footer">' +
            '<a class="btn eb-handle-remove-modal-confirm remove-btn" index="1" href="#">Remove</a>' +
            '<button class="btn eb-handle-cancel-modal-confirm-remove">Cancel</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(cart); document.body.appendChild(top);
    document.body.appendChild(ov); document.body.appendChild(dw); document.body.appendChild(prev);
    el.cart = cart; el.badge = cart.querySelector('.szmc-cart__badge'); el.top = top;
    el.ring = top.querySelector('.szmc-top__bar'); el.ov = ov; el.dw = dw; el.prev = prev;
    try { RING_C = 2 * Math.PI * 18.5; el.ring.style.strokeDasharray = RING_C.toFixed(1); el.ring.style.strokeDashoffset = RING_C.toFixed(1); } catch (e) {}
    if (isCartPage()) cart.style.display = 'none';        // đang ở chính trang giỏ thì không cần nút
    state.built = true;

    var cached = ss(CACHE_HTML);
    if (cached) dw.innerHTML = cached;
    wire();
  }

  /* ---------- nạp HTML section (nguồn duy nhất của ruột drawer) ---------- */
  function fetchSectionHTML(cb) {
    try {
      pfetch('/?section_id=' + SECTION, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Section Rendering API trả về đúng nội dung section (có thể bọc div#shopify-section-…)
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var inner = tmp.querySelector('#shopify-section-' + SECTION) || tmp.querySelector('[id^="shopify-section"]');
          var out = (inner ? inner.innerHTML : html);
          ss(CACHE_HTML, out);
          if (cb) cb(out);
        })
        .catch(function () { if (cb) cb(null); });
    } catch (e) { if (cb) cb(null); }
  }
  function fetchSection(cb) {
    fetchSectionHTML(function (out) {
      if (out && el.dw) { el.dw.innerHTML = out; syncFromDom(); szmcPendInject(); }
      if (cb) cb(out);
    });
  }

  function syncFromDom() {
    try {
      var box = el.dw.querySelector('.szmc-dw__body');
      var n = box ? parseInt(box.getAttribute('data-szmc-count') || '0', 10) : 0;
      setCount(n);
      tickTimer();
    } catch (e) {}
  }
  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 18:05 VN — WEB-20260915-suzitee-header-count-sync
     Đã làm: thêm szmcPaintHeader(n) sơn lại badge giỏ trên HEADER (.cart_count = số ở icon giỏ
     góc phải desktop, .cart_count-mobile-number = badge mask-SVG trên mobile) và gọi nó ở ngay
     đầu setCount(). TRƯỚC: setCount chỉ sơn .szmc-cart__badge (bong bóng MY CART), nên đổi số
     lượng trong mini-cart rồi bấm X đóng thì số trên icon giỏ góc phải vẫn là số CŨ, chỉ đúng sau
     khi tải lại trang (anh Hoá báo 17:53 VN). SAU: mọi đường gọi setCount (patchTotals sau
     /cart/change.js, syncFromDom sau khi nạp section, và cú /cart.js lúc init) đều đồng bộ luôn
     header ⇒ không cần reload. Đặt TRƯỚC `if (!el.badge) return;` để header vẫn đúng ngay cả khi
     bong bóng chưa dựng xong. KHÔNG đụng el.cart.hidden / cart.style.display ⇒ bong bóng MY CART
     vẫn ẩn trên /cart đúng như anh Hoá duyệt 17:08-17:09, và khối qty-inert mobile giữ nguyên. */
  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 18:30 VN — WEB-20260915-suzitee-cart-title-count
     Đã làm: thêm szmcPaintCartTitle(n) sơn lại dòng tiêu đề "N items in your cart:" của trang /cart
     (thẻ h1 trong sections/cart-template.liquid, không có class/id nên nhận diện bằng chính câu chữ)
     và gọi nó từ szmcPaintHeader — tức là CÙNG MỘT painter với badge header, không tạo painter thứ 2.
     TRƯỚC: Liquid render con số 1 lần lúc tải trang; bấm +/- trên /cart chỉ cập nhật Subtotal + badge
     nên dòng này đứng im (giỏ 3 vẫn ghi "2 items in your cart:") cho tới khi F5 — lỗi CÓ SẴN của theme,
     đã đối chứng trên bản live chưa vá. SAU: mọi đường sơn số (setCount từ drawer, totals() của trang
     /cart, add-to-cart) đều cập nhật luôn dòng này ⇒ không bao giờ lệch với badge/dock/subtotal.
     Nguồn số: cart.item_count từ /cart.js hoặc /cart/change.js (TỔNG số món, không phải số dòng).
     Giữ nguyên markup: chỉ thay đúng con số và chữ item/items trong innerHTML (số ít "1 item",
     số nhiều "N items", giỏ rỗng "0 item in your cart:" — đúng y như Liquid render). */
  function szmcPaintCartTitle(n) {
    try {
      if (!isCartPage()) return;
      var sec = document.getElementById('shopify-section-cart-template') || document;
      var hs = sec.querySelectorAll('h1');
      for (var i = 0; i < hs.length; i++) {
        var h = hs[i], html = h.innerHTML;
        if (!/items?\s+in\s+your\s+cart/i.test(html)) continue;
        if (!/\d/.test(html)) continue;
        var s = String(n > 0 ? n : 0);
        var next = html
          .replace(/\d+/, s)
          .replace(/\bitems\b(?=[\s\S]{0,40}?in\s+your\s+cart)/i, n > 1 ? 'items' : 'item')
          .replace(/\bitem\b(?=[\s\S]{0,40}?in\s+your\s+cart)/i, n > 1 ? 'items' : 'item');
        if (next !== html) h.innerHTML = next;
        break;
      }
    } catch (e) {}
  }
  function szmcPaintHeader(n) {
    try {
      var s = String(n > 0 ? n : 0);
      [].forEach.call(document.querySelectorAll('.cart_count'), function (x) { x.textContent = s; });
      [].forEach.call(document.querySelectorAll('.cart_count-mobile-number'), function (x) { x.textContent = s; });
      szmcPaintCartTitle(n > 0 ? n : 0);
    } catch (e) {}
  }
  function setCount(n) {
    state.count = n;
    szmcPaintHeader(n);
    if (!el.badge) return;
    el.badge.textContent = n;
    el.cart.hidden = !(n > 0);                              // GIỎ RỖNG -> ẨN NÚT (giống Almagems)
  }

  /* ---------- đồng hồ giữ giỏ trong drawer (HTML nạp động nên DOMContentLoaded không chạy) ---------- */
  var timerIv = null;
  function tickTimer() {
    if (timerIv) { clearInterval(timerIv); timerIv = null; }
    var sp = el.dw.querySelectorAll('.countdown_time');
    if (sp.length < 3) return;
    var count = 10 * 60;
    timerIv = setInterval(function () {
      if (!state.open) return;
      if (count <= 0) { count = 10 * 60; return; }
      count -= 1;
      var m = Math.floor(count / 60);
      sp[0].innerText = String(m).padStart(2, '0');
      sp[2].innerText = String(count - m * 60).padStart(2, '0');
    }, 1000);
  }

  /* ---------- mở / đóng ---------- */
  function open(src) {
    if (src === 'atc') { szmcPendEnd(); szmcWarmPreview(); }
    /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 VN — WEB-20261009-suzitee-atc-mode. Đã làm: đo bấm→giỏ đầy đủ + gỡ spinner chế độ wait. */
    if (src === 'atc') { try { szAtcWaitEnd(true); } catch (e) {} }
    var t0 = (window.performance && performance.now) ? performance.now() : 0;
    build();
    metrics.fromCache = !!ss(CACHE_HTML);
    if (!el.dw.innerHTML) { /* chưa có cache -> vẽ khung rỗng rồi nạp */ el.dw.innerHTML = '<div class="szmc-dw__head"><h2 class="szmc-dw__title">Shopping Cart</h2><button type="button" class="szmc-dw__close" aria-label="Close">&times;</button></div><div class="szmc-dw__body"></div>'; }
    state.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 VN — fix khoá cuộn sót sau khi đóng giỏ:
    // nếu giỏ đang mở (open gọi lần 2) KHÔNG chụp lại style (tránh chụp chính khoá overflow:hidden của mình);
    // và bỏ overflow/position/top/touch-action khỏi bản chụp để close() không khôi phục khoá của popup khác.
    if (!state.open) {
      var szStrip = function (v) { if (v == null) return null; v = v.replace(/(^|;)\s*(overflow(-x|-y)?|position|top|touch-action|overscroll-behavior)\s*:[^;]*/gi, '$1').replace(/^;+|;+$/g, '').trim(); return v || null; };
      state.bodyInline = szStrip(document.body.getAttribute('style'));
      state.htmlInline = szStrip(document.documentElement.getAttribute('style'));
    }
    document.documentElement.classList.add('szmc-open');
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 12:40 VN — WEB-20260915-suzitee-minicart-feedback-1229
    // Đã làm (item 4): khoá cuộn CỨNG 2 chiều kiểu Almagems. Trước chỉ set body.overflow:hidden —
    // iOS Safari vẫn cuộn nền + di ngang. Nay: (a) MOBILE set overflow:hidden trên CẢ <html> lẫn <body>;
    // (b) trình chặn touchmove ở dưới preventDefault mọi cú kéo ngoài vùng cuộn hợp lệ -> khoá thật sự
    // trên iOS Safari cả DỌC lẫn NGANG (đây mới là cơ chế chặn iOS đáng tin — position:fixed gây nhảy
    // trang + không cần khi đã chặn touchmove). desktop chỉ cần overflow:hidden.
    state.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 VN — WEB-20261009-minicart-desktop-lock.
       Đã làm: desktop (>798px) khoá kiểu Almagems "soft lock" (cart-drawer.js lockPageScroll trên PDP desktop):
       KHÔNG đổi style html/body (=> 0 nhảy layout, giữ scrollbar/sticky), chặn wheel/touchmove/phím cuộn ở
       document {passive:false} trừ khi đang cuộn bên trong drawer/popup. Trước: chỉ body.overflow:hidden nhưng
       trang cuộn trên <html> nên wheel vẫn trôi nền. Mobile giữ nguyên như cũ. */
    var szMob = !!(window.matchMedia && window.matchMedia('(max-width:798px)').matches);
    if (szMob) document.body.style.overflow = 'hidden'; else szmcSoftLock(true);
    if (szMob) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overscrollBehavior = 'none';
    }
    state.open = true;
    // đo lúc drawer thật sự nhìn thấy (sau frame vẽ)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        metrics.openMs = ((window.performance && performance.now) ? performance.now() : 0) - t0;
        try { document.dispatchEvent(new CustomEvent('szmc:open', { detail: { ms: metrics.openMs, src: src } })); } catch (e) {}
      });
    });
    tickTimer();
    /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 03:00 VN — WEB-20261009-suzitee-customily-atc-r10
       Đã làm: open('atc') gọi ngay sau khi vừa có HTML giỏ mới (bundled sections / fetchSection) -> bỏ lượt
       nạp section LẦN 2 (trước: 2 GET ?section_id=sz-minicart liên tiếp, lần 2 vẽ đè dòng hàng vừa hiện). */
    if (!(src === 'atc' && Date.now() - szmcFresh < 1500)) fetchSection();   // refresh ngầm, không chặn khung nhìn
  }
  /* WEB-20261009-minicart-desktop-lock: soft lock desktop kiểu Almagems (xem open()). */
  var szSoft = false;
  function szSoftOk(t, dy) {
    if (!t || t.nodeType !== 1) t = t && t.parentElement;
    if (!t || !t.closest) return false;
    // popup khác (Customily Preview / vue-js-modal / dialog) mở chồng lên: để nó tự lo
    if (t.closest('.customily-modal-preview-only, .vm--container, .vm--modal, [role="dialog"][aria-modal="true"], .fancybox-container') && !(el.dw && el.dw.contains(t))) return true;
    var root = el.dw && el.dw.contains(t) ? el.dw : (el.prev && el.prev.contains && el.prev.contains(t) ? el.prev : null);
    if (!root) return false;
    for (var e = t; e && e !== root.parentNode; e = e.parentElement) {
      var c = getComputedStyle(e);
      if (/(auto|scroll)/.test(c.overflowY) && e.scrollHeight > e.clientHeight + 1) {
        if (dy == null || dy === 0) return true;
        if (dy < 0 && e.scrollTop > 0) return true;
        if (dy > 0 && e.scrollTop + e.clientHeight < e.scrollHeight - 1) return true;
      }
    }
    return false;   // trong drawer nhưng hết chỗ cuộn -> chặn để không trôi xuống nền
  }
  function szSoftWheel(ev) { if (!state.open || ev.ctrlKey) return; if (!szSoftOk(ev.target, ev.deltaY) && ev.cancelable) ev.preventDefault(); }
  var szSoftTy = 0;
  function szSoftTs(ev) { szSoftTy = ev.touches && ev.touches[0] ? ev.touches[0].clientY : 0; }
  function szSoftTm(ev) { if (!state.open || (ev.touches && ev.touches.length > 1)) return; var dy = ev.touches && ev.touches[0] ? szSoftTy - ev.touches[0].clientY : 0; if (!szSoftOk(ev.target, dy) && ev.cancelable) ev.preventDefault(); }
  function szSoftKey(ev) {
    if (!state.open) return;
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(ev.key) < 0) return;
    var a = document.activeElement;
    if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return;
    if (a && el.dw && el.dw.contains(a) && a !== el.dw) return;
    ev.preventDefault();
  }
  function szmcSoftLock(on) {
    if (on === szSoft) return;
    szSoft = on;
    var f = on ? 'addEventListener' : 'removeEventListener';
    document[f]('wheel', szSoftWheel, on ? { passive: false, capture: true } : { capture: true });
    document[f]('touchstart', szSoftTs, on ? { passive: true, capture: true } : { capture: true });
    document[f]('touchmove', szSoftTm, on ? { passive: false, capture: true } : { capture: true });
    document[f]('keydown', szSoftKey, true);
  }
  function szmcUnlockScroll() {
    if (state.open) return;
    var vis = [].some.call(document.querySelectorAll('.vm--container, .vm--modal, [role="dialog"][aria-modal="true"], .fancybox-container'), function (m) {
      if (/szmc|klaviyo|needsclick/i.test((m.className || '') + ' ' + (m.id || ''))) return false;
      var c = getComputedStyle(m), r = m.getBoundingClientRect();
      return c.display !== 'none' && c.visibility !== 'hidden' && r.width > 50 && r.height > 50;
    });
    if (vis) return;
    var bd = document.body, h = document.documentElement;
    ['vm--block-scroll', 'customily-open', 'modal-open', 'no-scroll', 'overflow-hidden', 'js-drawer-open', 'js-drawer-open-right', 'fancybox-active', 'compensate-for-scrollbar', 'lock-scroll', 'scroll-lock'].forEach(function (k) { bd.classList.remove(k); h.classList.remove(k); });
    var fixedTop = bd.style.position === 'fixed' ? Math.abs(parseInt(bd.style.top, 10) || 0) : null;
    ['overflow', 'overflowX', 'overflowY', 'position', 'top', 'touchAction', 'overscrollBehavior'].forEach(function (p) { bd.style[p] = ''; h.style[p] = ''; });
    if (fixedTop) { try { window.scrollTo(0, fixedTop); } catch (e) {} }
  }
  function close() {
    var t0 = (window.performance && performance.now) ? performance.now() : 0;
    document.documentElement.classList.remove('szmc-open');
    try { szmcSoftLock(false); } catch (e) {}
    if (state.bodyInline == null) document.body.removeAttribute('style'); else document.body.setAttribute('style', state.bodyInline);
    // feedback-1229 item 4: khôi phục luôn style gốc của <html> (đã set overflow:hidden khi mở trên mobile)
    if (state.htmlInline == null) document.documentElement.removeAttribute('style'); else document.documentElement.setAttribute('style', state.htmlInline);
    state.open = false;
    try { window.scrollTo(0, state.scrollY); } catch (e) {}
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 VN: gỡ sạch mọi khoá cuộn còn sót (popup Preview
    // Customily/vue-js-modal bị ẩn bằng display:none nên không tự gỡ vm--block-scroll...) nếu không còn modal thật mở.
    try { szmcUnlockScroll(); setTimeout(szmcUnlockScroll, 350); } catch (e) {}
    requestAnimationFrame(function () { metrics.closeMs = ((window.performance && performance.now) ? performance.now() : 0) - t0; });
  }

  /* ---------- đổi số lượng / xoá ----------
     r2b (lỗi 4 anh báo 01:54): KHÔNG làm mờ cả drawer nữa. Cập nhật LẠC QUAN: số lượng + Subtotal
     đổi ngay tại chỗ, chỉ khoá nhẹ đúng ô số lượng; sau khi server trả lời thì vá LẠI ĐÚNG DÒNG đó
     (và Subtotal/tiêu đề/badge), không vẽ lại toàn bộ danh sách. */
  /* r5-usd (2026-09-15 ~04:2x VN) — AI Agent làm theo chỉ thị anh Hoá (lỗi vừa dính bản LIVE).
     Đã làm: BỎ toLocaleString({style:'currency'}). Vì sao: trình duyệt tiếng Việt (vi-VN) render USD
     thành **"US$24.95"**, cộng thêm span " USD" của dock => "US$24.95 USD". Headless mặc định en-US
     nên QC cũ KHÔNG thấy. Nay format tay theo money_format của shop ("${{amount}}"), KHÔNG bao giờ
     sinh "US$", KHÔNG tự thêm đuôi USD (span .js-sz-mdock-cur là nguồn DUY NHẤT). */
  function money(c) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var out = Shopify.formatMoney(c, (window.Shopify && Shopify.money_format) || '${{amount}}');
        if (out && out.indexOf('US$') < 0) return out;
      }
    } catch (e) {}
    try {
      var n = (Number(c) || 0) / 100, s = n.toFixed(2).split('.');
      return '$' + s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '.' + s[1];
    } catch (e2) { return '$' + ((Number(c) || 0) / 100).toFixed(2); }
  }

  /* ---------- r4b (2026-09-15 ~03:4x VN, WEB-20260915-suzitee-minicart-r4b) ----------
     AI Agent lam theo chi thi cua anh Hoa.
     Da lam: chuan hoa duoi ma tien te o Subtotal (dock trang /cart + dock trong drawer):
     - xoa moi ma tien te dinh SAN trong so tien (vd ".money" bi app doi tien te ghi "$274.45 USD"),
     - giu DUNG MOT the <span class="js-sz-mdock-cur"> " USD" </span> trong moi .sz-mdock__amt.
     Vi sao: truoc day trang /cart co san span cua theme, con drawer dung CSS ::after; khi app doi
     tien te ghi ma vao chinh so tien thi thanh "$274.45 USD USD". r4b bo ::after, chi 1 nguon nay. */
  function szmcCur() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }
    catch (e) { return 'USD'; }
  }
  var __szmcFixing = 0;
  function szmcCurFix(root) {
    if (__szmcFixing) return;
    __szmcFixing = 1;
    try {
      var code = szmcCur();
      var rx = new RegExp('[\\s\\u00a0]*\\b' + code + '\\b[\\s\\u00a0]*$');
      var amts = (root || document).querySelectorAll('.sz-mdock__amt');
      [].forEach.call(amts, function (amt) {
        var pr = amt.querySelector('.js-sz-mdock-price');
        if (pr) {
          var t = pr.textContent || '';
          var cl = t;
          while (rx.test(cl)) cl = cl.replace(rx, '');
          /* r5-usd: lưới cuối — app/locale nào ghi "US$24.95" (vi-VN) thì trả về "$24.95". */
          cl = cl.replace(/\bUS\$/g, '$').replace(/\bUS\s*\$/g, '$');
          cl = cl.replace(/[\s\u00a0]+$/, '');
          if (cl !== t) pr.textContent = cl;
        }
        var curs = amt.querySelectorAll('.js-sz-mdock-cur');
        for (var i = 1; i < curs.length; i++) curs[i].parentNode.removeChild(curs[i]);
        var s = curs[0];
        if (!s) {
          s = document.createElement('span');
          s.className = 'js-sz-mdock-cur';
          amt.appendChild(s);
        }
        var want = ' ' + code;
        if (s.textContent !== want) s.textContent = want;
        if (s.parentNode !== amt) amt.appendChild(s);
      });
    } catch (e) {}
    __szmcFixing = 0;
  }
  function szmcCurWatch() {
    try {
      szmcCurFix();
      var run = function () { szmcCurFix(); };
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () {
          if (__szmcFixing) return;
          clearTimeout(szmcCurWatch._t);
          szmcCurWatch._t = setTimeout(run, 60);
        });
        mo.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
      }
      [300, 900, 1800, 3500, 6000].forEach(function (ms) { setTimeout(run, ms); });
      window.addEventListener('load', run);
    } catch (e) {}
  }

  function patchTotals(c) {
    try {
      var t = el.dw.querySelector('.szmc-dw__title');
      if (t) t.textContent = 'Shopping Cart (' + (c.item_count || 0) + ')';
      var s = el.dw.querySelector('.sz-mdock__price');
      if (s) s.textContent = money(c.total_price != null ? c.total_price : 0);
      setCount(c.item_count || 0);
      szmcCurFix(el.dw);                                 // r4b: dung 1 chu USD
    } catch (e) {}
  }
  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 10:10 VN — WEB-20261018-suzitee-cart-addon-order
     Đã làm: THỨ TỰ GIỎ — SP chính nằm TRÊN, add-on (Gift Box/Damage-Proof… tick sẵn ở PDP) nằm NGAY DƯỚI SP của nó.
     Gốc (đo trên nháp 189178773807): form ATC gửi `id`=SP chính + `items[1]id`=add-on trong 1 request /cart/add.js;
     Shopify đẩy món gửi SAU lên đầu giỏ → add-on nằm trên SP chính. Nay: (1) đổi thứ tự gửi = add-on trước
     (items[0]) rồi SP chính (items[1], giữ NGUYÊN mọi properties/Customily, chỉ đổi tiền tố tên field);
     (2) gắn khoá nhóm ẩn `_sz_grp` (SP chính) = `_addon_for` (add-on) → mỗi SP có dòng add-on riêng (không gộp
     số lượng vào add-on của SP khác) và (3) xoá SP chính → add-on mồ côi cùng khoá tự xoá theo (drawer + /cart),
     không trôi sang dưới SP khác. Dòng cũ không có khoá: không đụng. Gửi lỗi định dạng → giữ body gốc. */
  function szmcAddonFirst(src, mk) {
    try {
      var aid = src.get('items[1]id'), mid = src.get('id');
      if (!aid || !mid) return src;
      var other = false;
      src.forEach(function (v, k) { if (/^items\[/.test(k) && k !== 'items[1]id' && k !== 'items[1]quantity') other = true; });
      if (other) return src;                               /* khuôn lạ (nhiều add-on/app khác) -> giữ nguyên */
      var g = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var out = mk();
      out.append('items[0][id]', aid);
      out.append('items[0][quantity]', src.get('items[1]quantity') || '1');
      out.append('items[0][properties][_addon_for]', g);
      src.forEach(function (v, k) {
        if (k === 'items[1]id' || k === 'items[1]quantity') return;
        if (k === 'id') out.append('items[1][id]', v);
        else if (k === 'quantity') out.append('items[1][quantity]', v);
        else if (k === 'selling_plan') out.append('items[1][selling_plan]', v);
        else if (k.indexOf('properties[') === 0) out.append('items[1][properties]' + k.slice(10), v);
        else out.append(k, v);
      });
      out.append('items[1][properties][_sz_grp]', g);
      return out;
    } catch (e) { return src; }
  }
  function szmcAddonOrphans(c) {
    var has = {}, out = [], it = (c && c.items) || [];
    it.forEach(function (i) { var g = i.properties && i.properties._sz_grp; if (g) has[g] = 1; });
    it.forEach(function (i) { var a = i.properties && i.properties._addon_for; if (a && !has[a]) out.push(i.key); });
    return out;
  }
  function szmcSweepAddons(c, cb) {
    var o = szmcAddonOrphans(c);
    if (!o.length) { cb(null); return; }
    var u = {}; o.forEach(function (k) { u[k] = 0; });
    pfetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: u })
    }).then(function (r) { return r.json(); })
      .then(function (c2) { if (c2 && c2.items) ss(CACHE_CART, JSON.stringify(c2)); cb(c2 && c2.items ? c2 : null); })
      .catch(function () { cb(null); });
  }

  function change(line, qty, optimisticEl) {
    if (state.busy) return; state.busy = true; window.__szmcSelf = Date.now();
    var box = optimisticEl && optimisticEl.closest('.cart__item');
    if (box) box.classList.add('szmc-line-busy');
    pfetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) {
        ss(CACHE_CART, JSON.stringify(c));
        /* WEB-20261018-suzitee-cart-addon-order: xoá SP chính -> xoá luôn add-on cùng khoá (nếu có) rồi mới vẽ lại */
        szmcSweepAddons(c, function (c2) {
          if (c2) c = c2;
          patchTotals(c);                                // Subtotal/tiêu đề đúng số thật ngay
          fetchSectionPatch(function () { state.busy = false; });
        });
      })
      .catch(function () { state.busy = false; if (box) box.classList.remove('szmc-line-busy'); });
  }
  // nạp lại section nhưng CHỈ thay phần thân + đáy (giữ nguyên khung/đầu -> không nháy)
  function fetchSectionPatch(cb) {
    fetchSectionHTML(function (html) {
      if (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nb = tmp.querySelector('.szmc-dw__body'), ob = el.dw.querySelector('.szmc-dw__body');
        var nf = tmp.querySelector('.szmc-dw__foot'), of_ = el.dw.querySelector('.szmc-dw__foot');
        if (nb && ob) ob.replaceWith(nb); else if (nb && !ob) el.dw.appendChild(nb);
        if (nf && of_) of_.replaceWith(nf); else if (nf && !of_) el.dw.appendChild(nf); else if (!nf && of_) of_.remove();
        var nt = tmp.querySelector('.szmc-dw__title'), ot = el.dw.querySelector('.szmc-dw__title');
        if (nt && ot) ot.textContent = nt.textContent;
        syncFromDom();
      }
      if (cb) cb();
    });
  }

  /* ---------- dọn dẹp sau khi app ngoài (Customily) thêm hàng xong ----------
     r2c (P0 02:08): nút của app kẹt "ADDING TO CART..." và modal app không tự đóng vì nó chờ điều hướng
     sang /cart (thứ mà drawer đã thay thế). Ta KHÔNG can thiệp request của app; chỉ dọn UI sau khi xong. */
  function afterExternalAdd() {
    try {
      // (a) trả nút về trạng thái cũ
      [].forEach.call(document.querySelectorAll('button,a,.btn'), function (b) {
        var t = (b.textContent || '').trim();
        if (/adding to cart/i.test(t)) {
          b.textContent = b.getAttribute('data-szmc-label') || 'ADD TO CART';
          b.disabled = false; b.classList.remove('loading', 'is-loading', 'disabled');
        }
      });
      // (a2) nút của Customily dùng thư viện ldbtn: trạng thái chạy nằm ở class .running/.ld-over*
      [].forEach.call(document.querySelectorAll('#customily-cart-btn,.customily-preview-button,.add_to_cart'), function (b) {
        b.classList.remove('running'); b.disabled = false;
        if (b.getAttribute('data-szmc-label')) b.innerHTML = b.getAttribute('data-szmc-label');
      });
      // (b) đóng modal của Customily: thử nút đóng của chính nó trước, không được thì ẩn lớp phủ
      var sels = ['.customily-preview-modal', '.cust-preview-modal', '[class*="customily"][class*="modal"]',
                  '[id*="customily"][class*="modal"]', '.cly-modal', '.preview-modal', '[class*="cl-modal"]'];
      var seen = [];
      sels.forEach(function (s) { [].forEach.call(document.querySelectorAll(s), function (m) { if (seen.indexOf(m) < 0) seen.push(m); }); });
      // quét thêm: lớp phủ cố định, phủ gần hết màn, KHÔNG phải của mình, có dấu vết Customily bên trong
      [].forEach.call(document.querySelectorAll('body > div, body > section'), function (m) {
        if (seen.indexOf(m) >= 0 || m.id === 'szmcModals' || /szmc-/.test(m.className || '')) return;
        var c = getComputedStyle(m), r = m.getBoundingClientRect();
        if (c.position !== 'fixed' || c.display === 'none') return;
        if (r.width < innerWidth * 0.5 || r.height < innerHeight * 0.5) return;
        if (!/customily|cl-option|cly-/i.test(m.innerHTML.slice(0, 4000))) return;
        seen.push(m);
      });
      seen.forEach(function (m) {
        if (getComputedStyle(m).display === 'none') return;
        var x = m.querySelector('[class*="close"],[aria-label*="lose"],button.close');
        if (x) { try { x.click(); } catch (e) {} }
        if (getComputedStyle(m).display !== 'none') m.style.display = 'none';
      });
      // (c) trả lại cuộn trang nếu app khoá body
      try { document.body.classList.remove('customily-open', 'modal-open', 'no-scroll', 'vm--block-scroll'); } catch (e) {}
    } catch (e) {}
  }

  /* ---------- modal helper (dùng markup + class của trang /cart) ---------- */
  function showModal(id) {
    var m = el.prev.querySelector('#' + id); if (!m) return;
    /* r4: ảnh preview hỏng (URL chết) thì ẨN hẳn, không để chừa một mảng trắng to trong modal */
    [].forEach.call(m.querySelectorAll('img.eb-cus-preview-modal-content'), function (im) {
      im.style.display = '';
      im.onerror = function () { this.style.display = 'none'; };
      im.onload = function () { this.style.display = ''; };
      if (im.complete && im.naturalWidth === 0 && im.getAttribute('src')) im.style.display = 'none';
    });
    el.prev.classList.add('is-on'); m.classList.remove('is-hidden');
  }
  /* r5 (2026-09-15 ~06:0x VN) — AI Agent làm theo chỉ thị anh Hoá.
     LỖI QC r5 BẮT ĐƯỢC (ảnh + số đo): đóng modal Preview TRONG drawer thì **drawer đóng theo**
     (đo được: html.szmc-open true -> false, drawer trượt ra x=390). Vì sao: modal `position:fixed;inset:0`
     nằm ĐÈ lên lớp mờ `.szmc-ov`; trên thiết bị chạm, trình duyệt bắn `click` NGAY SAU `touchend`
     tại cùng toạ độ — modal đã ẩn ở touchend nên cú `click` đuôi rơi trúng lớp mờ => close().
     Vá: sau khi ẩn modal, KHOÁ lớp mờ 450ms (lớp mờ chỉ đóng drawer khi khách bấm thật vào nó). */
  var ovLockUntil = 0;
  function hideModals() {
    el.prev.classList.remove('is-on');
    [].forEach.call(el.prev.querySelectorAll('.eb-cus-preview-modal'), function (m) { m.classList.add('is-hidden'); });
    ovLockUntil = Date.now() + 450;
  }
  function previewSrc(line, lineEl) {
    var items = [];
    try { items = JSON.parse((el.dw.querySelector('[data-szmc-cart]') || {}).textContent || '[]'); } catch (e) {}
    var p = (items[line - 1] && items[line - 1].properties) || {};
    return p['_customily-preview'] || p['_customall_preview'] ||
      ((lineEl && lineEl.querySelector('img')) || {}).src || '';
  }

  /* ---------- r3: ô số lượng (1 lần bấm = đúng 1 đơn vị, quay tròn TRONG ô) ----------
     - handler DUY NHẤT, pha capture, chặn lan truyền -> theme không cộng thêm lần nữa
     - đang gọi server thì khoá đúng dòng đó (không làm mờ cả drawer), nhả khi có đáp
     - có đáp: vá đúng dòng (số lượng + giá dòng) + Subtotal + tiêu đề + badge, KHÔNG vẽ lại danh sách */
  var qtyLock = {};
  /* r4 (loi 4 anh bao 02:46): CHO bam lien tuc. Moi lan bam -> so hien thi +1/-1 NGAY,
     KHONG khoa nut, KHONG quay tron. Sau 400ms ke tu lan bam CUOI moi goi DUY NHAT
     mot /cart/change voi so cuoi cung, luc do moi hien quay tron trong o. */
  var qtyTimer = {}, qtyWant = {}, QTY_DEBOUNCE = 400;
  function lineSpin(item, on) {
    if (!item) return;
    var box = item.querySelector('.product-quantity-box'); if (!box) return;
    if (on) {
      item.classList.add('szmc-qty-wait');
      if (!box.querySelector('.szmc-qty-spin')) {
        var sp = document.createElement('span'); sp.className = 'szmc-qty-spin'; box.appendChild(sp);
      }
    } else {
      item.classList.remove('szmc-qty-wait');
      var old = box.querySelector('.szmc-qty-spin'); if (old) old.remove();
    }
  }
  function patchLine(item, it) {
    if (!item || !it) return;
    var inp = item.querySelector('input.quantity'); if (inp) inp.value = it.quantity;
    var lp = item.querySelector('[data-line-price], .cart__item--price .money');
    if (lp) lp.textContent = money(it.final_line_price != null ? it.final_line_price : it.line_price);
    var up = item.querySelector('.modal_price .money');
    if (up && it.final_price != null) up.textContent = money(it.final_price);
  }
  function qtyFlush(line, item) {
    var want = qtyWant[line];
    if (want == null) return;
    delete qtyWant[line];
    qtyLock[line] = 1;
    lineSpin(item, true);                                 // quay tron CHI khi dang goi server
    pfetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: want })
    }).then(function (r) { return r.json(); })
      .then(function (c) {
        ss(CACHE_CART, JSON.stringify(c));
        patchLine(item, (c.items || [])[line - 1]);
        patchTotals(c);
      })
      .catch(function () {})
      .then(function () {
        qtyLock[line] = 0; lineSpin(item, false);
        if (qtyWant[line] != null) qtyFlush(line, item);  // co bam them luc dang bay -> gui tiep
      });
  }
  function qtyClick(e) {
    var t = e.target;
    var qb = t && t.closest && t.closest('.js-change-quantity');
    if (!qb || !el.dw.contains(qb)) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var item = qb.closest('.cart__item'); if (!item) return;
    var line = parseInt(item.getAttribute('data-line-id'), 10); if (!line) return;
    var input = item.querySelector('input.quantity');
    var base = qtyWant[line] != null ? qtyWant[line] : parseInt((input && input.value) || '1', 10);
    var next = qb.getAttribute('data-func') === 'plus' ? base + 1 : base - 1;
    if (next < 1) next = 1;                               // ve 0 thi dung nut thung rac
    if (next === base) return;
    qtyWant[line] = next;
    if (input) input.value = next;                        // SO DOI NGAY, nut khong bi khoa
    if (qtyTimer[line]) clearTimeout(qtyTimer[line]);
    qtyTimer[line] = setTimeout(function () {
      qtyTimer[line] = 0;
      if (qtyLock[line]) return;                          // dang bay -> flush lai o .then
      qtyFlush(line, item);
    }, QTY_DEBOUNCE);
  }

  /* ---------- gắn sự kiện ---------- */
  function wire() {
    /* r3 (lỗi 8 anh báo 02:16): ô số lượng nhảy 2 đơn vị vì theme cũng có handler cho .js-change-quantity.
       Bắt ở pha CAPTURE ngay trên drawer + chặn lan truyền -> chỉ CÒN DUY NHẤT handler này chạy.
       Cờ __szmcQtyBound chống gắn 2 lần khi drawer vẽ lại. */
    if (!el.dw.__szmcQtyBound) {
      el.dw.__szmcQtyBound = 1;
      el.dw.addEventListener('click', qtyClick, true);
    }
    /* r3: nhớ CHỮ GỐC của nút ATC (Customily đổi thành "ADDING TO CART...") để trả lại đúng nguyên văn */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('#customily-cart-btn,.add_to_cart,.customily-preview-button');
      if (b && !b.getAttribute('data-szmc-label') && !/adding/i.test(b.innerText || '')) {
        b.setAttribute('data-szmc-label', b.innerHTML);
      }
      if (b) markBack();                                   // r4 (P0-c): nho trang de quay ve neu bi day sang /cart
      var mb = e.target && e.target.closest && e.target.closest('.modal-cart-button,#customily-cart-btn,button[name="add"]');
      if (mb) markBack();
    }, true);
    el.cart.addEventListener('click', function (e) { e.preventDefault(); open('fab'); });
    el.ov.addEventListener('click', function () {
      if (Date.now() < ovLockUntil) return;   /* r5: bỏ cú click đuôi sau khi vừa đóng modal Preview */
      close();
    });
    el.top.addEventListener('click', function (e) { e.preventDefault(); toTop(); });
    el.top.addEventListener('touchend', function (e) { e.preventDefault(); toTop(); }, { passive: false });
    // AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 12:40 VN — WEB-20260915-suzitee-minicart-feedback-1229
    // Đã làm (item 4): chặn cuộn-nền khi drawer mở — touchmove ngoài vùng cuộn hợp lệ
    // (.szmc-dw__body danh sách hàng, hoặc thân modal Preview) đều preventDefault, nên backdrop/
    // header/footer không kéo được nền/drawer theo cả 2 chiều. passive:false để preventDefault có tác dụng.
    document.addEventListener('touchmove', function (e) {
      if (!state.open) return;
      var t = e.target;
      var ok = t && t.closest && t.closest('.szmc-dw__body, #szmc-preview-modal .eb-cus-preview-modal-wrapper, #szmc-remove-confirm .eb-cus-preview-modal-wrapper');
      if (!ok) { e.preventDefault(); }
    }, { passive: false });
    // modal của trang /cart: đóng + PROCEED TO CHECKOUT + xác nhận xoá
    el.prev.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.eb-cus-close') || t.classList.contains('eb-overlay-modal-confirm-remove') ||
          t.closest('.eb-handle-cancel-modal-confirm-remove')) {
        e.preventDefault(); hideModals(); return;
      }
      if (t.closest('.eb-checkout-btn')) { e.preventDefault(); location.href = '/checkout'; return; }
      var ok = t.closest('.eb-handle-remove-modal-confirm');
      if (ok) {
        e.preventDefault();
        var ln = parseInt(ok.getAttribute('data-szmc-line') || '0', 10);
        hideModals();
        if (ln) change(ln, 0);
      }
    });

    el.dw.addEventListener('click', function (e) {
      var t = e.target;
      var close1 = t.closest && t.closest('.szmc-dw__close');
      /* r5: nút X của modal Preview nằm ĐÚNG chỗ nút X của drawer (góc trên–phải). Trên thiết bị chạm,
         cú `click` đuôi sau `touchend` rơi trúng X của drawer khi modal vừa ẩn => drawer đóng oan.
         Đo được: html.szmc-open true -> false ngay sau khi đóng modal. Khoá 450ms giống lớp mờ. */
      if (close1) { e.preventDefault(); if (Date.now() < ovLockUntil) return; close(); return; }
      var qb = t.closest && t.closest('.js-change-quantity');
      if (qb) { e.preventDefault(); return; }         // r3: đã xử lý ở handler CAPTURE (qtyClick)
      var rm = t.closest && t.closest('.cart-remove-btn');
      if (rm) {
        e.preventDefault();
        var it2 = rm.closest('.cart__item'); if (!it2) return;
        var ln2 = parseInt(it2.getAttribute('data-line-id'), 10);
        // hàng cá nhân hoá -> hỏi lại ĐÚNG như trang /cart (lỗi 2 anh báo 01:54)
        if (it2.querySelector('.customily-preview-cart')) {
          var img2 = el.prev.querySelector('#szmc-prev-img-remove');
          if (img2) img2.src = previewSrc(ln2, it2) || '';
          var ok2 = el.prev.querySelector('#szmc-remove-confirm .eb-handle-remove-modal-confirm');
          if (ok2) ok2.setAttribute('data-szmc-line', String(ln2));
          showModal('szmc-remove-confirm');
        } else { change(ln2, 0, rm); }
        return;
      }
      var pv = t.closest && (t.closest('.customily-preview-cart') || t.closest('.preview-image'));
      if (pv) {
        e.preventDefault();
        var it3 = pv.closest('.cart__item'); if (!it3) return;
        var ln3 = parseInt(it3.getAttribute('data-line-id'), 10);
        var img3 = el.prev.querySelector('#szmc-prev-img');
        if (img3) {
          /* 00:05 VN 9/10: ảnh SP thường/add-on trong popup trước dùng nguyên thumbnail 150–300px → phóng to bị mờ.
             Nay: hiện thumbnail ngay (không trắng), CHỈ khi bấm mới tải bản nét theo khung × DPR (≤1000px, CDN Shopify tự webp/avif), xong thì thay. */
          var th3 = it3.querySelector('img'), s3 = previewSrc(ln3, it3) || '';
          if (th3 && s3 === th3.src && th3.currentSrc) s3 = th3.currentSrc;
          img3.removeAttribute('srcset'); img3.src = s3; img3.__szHi = '';
          try {
            var pp3 = {}; try { pp3 = (JSON.parse((el.dw.querySelector('[data-szmc-cart]') || {}).textContent || '[]')[ln3 - 1] || {}).properties || {}; } catch (_p) {}
            var perso3 = !!(pp3['_customily-preview'] || pp3['_customall_preview'] || pp3['_customily-customization-url'] || pp3['_customall_print_file']);
            if (!perso3 && /\/cdn\/shop\/|cdn\.shopify\.com/.test(s3)) {
              var wv = Math.min(window.innerWidth * 0.9, 800), w3 = Math.min(1000, Math.ceil(wv * Math.min(window.devicePixelRatio || 1, 2) / 100) * 100);
              var u3 = new URL(s3, location.href); u3.searchParams.set('width', w3); u3.searchParams.delete('height'); u3.searchParams.delete('crop');
              var hi3 = u3.toString(); img3.__szHi = hi3;
              var pre3 = new Image(); pre3.decoding = 'async';
              pre3.onload = function () { if (img3.__szHi === hi3) img3.src = hi3; };
              pre3.src = hi3;
            }
          } catch (_e3) {}
        }
        showModal('szmc-preview-modal');            // modal này CÓ nút PROCEED TO CHECKOUT
        return;
      }
    });
    // Enter trong ô số lượng
    el.dw.addEventListener('change', function (e) {
      var inp = e.target.closest && e.target.closest('input.quantity'); if (!inp) return;
      var it = inp.closest('.cart__item'); if (!it) return;
      change(parseInt(it.getAttribute('data-line-id'), 10), Math.max(0, parseInt(inp.value || '1', 10)));
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });

    /* --- cướp lối vào: icon giỏ ở header + mọi link /cart (trừ khi đang ở trang /cart) --- */
    document.addEventListener('click', function (e) {
      if (isCartPage()) return;                       // trang /cart giữ nguyên hành vi gốc
      var a = e.target.closest && e.target.closest('a[href*="/cart"], .cart-link, .header-cart, [href$="/cart"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/\/cart(\/?($|\?|#))/.test(href)) return;  // /cart/add, /cart/change… không đụng
      e.preventDefault(); e.stopPropagation(); open('header');
    }, true);

    /* r5: MỘT đường add duy nhất cho cả 2 lối vào (sự kiện 'submit' của khách bấm nút,
       và form.submit() do Customily gọi bằng code). nativeSubmit = lưới an toàn. */
    function szmcAddForm(f, nativeSubmit) {
      if (!f || f.__szmcAdding) return;
      f.__szmcAdding = 1; szmcPend.inflight = Date.now();
      setTimeout(function () { f.__szmcAdding = 0; }, 3000);
      markBack();
      /* r4 (P0): Customily vua tu them hang xong thi CLICK nut ATC goc cua theme -> khong add lai. */
      if (Date.now() - lastExtAdd < 4000) {
        setTimeout(function () { fetchSection(function () { afterExternalAdd(); open('atc'); }); }, 150);
        return;
      }
      var fd = new FormData(f), hasFile = false, params = new URLSearchParams();
      try {
        fd.forEach(function (v, k) {
          if (typeof v !== 'string') { hasFile = true; return; }
          params.append(k, v);
        });
      } catch (e2) { hasFile = true; }
      /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 12:35 VN — WEB-20261009-customily-failclosed
         Đã làm: chống add TRÙNG. Đo được (draft 188917874991, 390): khách bấm ATC khi ô trống (Customily báo đỏ) rồi điền
         + bấm lại → Customily gọi form.submit() 2 lần (~5s cách nhau) → 2 dòng hàng y hệt. Trước r5 trang nhảy /cart nên
         lần 2 không chạy (live chỉ 1 dòng). Nay: lối form.submit() bằng code, cùng nội dung (bỏ properties[_…] ẩn như thumb-id)
         trong 10s → không add lại, chỉ mở drawer. Khách tự bấm (sự kiện submit) không bị ảnh hưởng. */
      if (nativeSubmit) {
        try {
          var szDk = [];
          params.forEach(function (v, k) { if (!/^properties\[_/.test(k) && !/sections/.test(k)) szDk.push(k + '=' + v); });
          szDk = (f.action || '') + '|' + szDk.sort().join('&');
          if (szmcPend.dupKey === szDk && Date.now() - szmcPend.dupAt < 10000) {
            szmcPend.dupAt = Date.now(); f.__szmcAdding = 0;
            setTimeout(function () { fetchSection(function () { afterExternalAdd(); open('atc'); }); }, 150);
            return;
          }
          szmcPend.dupKey = szDk; szmcPend.dupAt = Date.now();
        } catch (eDup) {}
      }
      /* r4 (P0-b): co customily_upsell_atc -> lop boc cua Customily BO QUA request nay. */
      /* WEB-20261018-suzitee-cart-addon-order (AI Agent theo chỉ thị anh Hoá): add-on gửi TRƯỚC SP chính -> giỏ hiện SP chính trên,
         add-on ngay dưới. Đặt SAU khối chống-trùng (khoá nhóm ngẫu nhiên không lọt vào dupKey). */
      var szThumb = params.get('properties[_customily-thumb]');
      if (hasFile) fd = szmcAddonFirst(fd, function () { return new FormData(); });
      else params = szmcAddonFirst(params, function () { return new URLSearchParams(); });
      params.append('customily_upsell_atc', '1');
      /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 03:00 VN — WEB-20261009-suzitee-customily-atc-r10
         Đã làm: (a) xin Shopify trả luôn HTML section sz-minicart trong response /cart/add.js (Bundled Section
         Rendering: sections=…) -> bỏ 1 vòng GET ?section_id sau add (~220ms 4G); thiếu 'sections' thì fallback
         fetchSection như cũ. (b) nạp trước ảnh _customily-thumb song song với add -> dòng hàng hiện có ảnh ngay.
         KHÔNG đổi/bớt properties nào (chỉ thêm 2 tham số sections/sections_url Shopify tự bỏ qua khi lưu). */
      try {
        if (!hasFile) { params.append('sections', SECTION); params.append('sections_url', location.pathname); }
        else { fd.append('sections', SECTION); fd.append('sections_url', location.pathname); }
        szmcPrefetchImg(szThumb);
      } catch (e3) {}
      var body = hasFile ? fd : params;
      var opt = { method: 'POST', body: body, credentials: 'same-origin' };
      if (!hasFile) opt.headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' };
      var fell = 0, tries = 0;
      var fallback = function () {                     /* add hỏng -> trả về hành vi gốc, không để kẹt */
        if (fell || !nativeSubmit) return; fell = 1;
        try { f.__szmcNative = 1; nativeSubmit.call(f); } catch (e) {}
      };
      /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-31 04:20 VN — WEB-20261031-customio-r26-atc429 (port R2-2 Suzitee → Customio, R2-6 live)
         Đã làm: 429 (Cloudflare 1015 / Shopify "Too many attempts") hoặc 503 trên /cart/add.js
         -> KHÔNG rơi xuống fallback() (form POST toàn trang = trang lỗi CF, mất cá nhân hoá). Giữ nguyên trang + modal,
         đếm ngược "Too many requests, retrying in Ns…", tự gửi lại ĐÚNG body này: 10s → 20s → 40s (Retry-After ≤90s thì theo),
         tối đa 3 lần cho 1 lần bấm; hết lượt -> trả nút + toast có nút "Try again". 429 = Shopify CHƯA thêm hàng -> gửi lại không thể trùng dòng. */
      var onRateLimit = function (r) {
        var ra = 0; try { ra = parseInt(r.headers.get('Retry-After'), 10) || 0; } catch (eRa) {}
        szmcPend.dupKey = '';                          /* lần bấm lại không bị khối chống-trùng coi là "đã add" (sẽ mở giỏ rỗng) */
        try { if (szmcPend.on) { var by = szmcPend.byUs; szmcPendEnd(); if (by && !(state.count > 0)) close(); } } catch (eP) {}
        try { window.dispatchEvent(new CustomEvent('sz:atc-ratelimit', { detail: { status: r.status, attempt: tries, retryAfter: ra } })); } catch (eEv) {}
        if (tries >= SZRL_STEPS.length) {
          szrlSet(30000); szrlBtnsIdle();
          szrlNote('We\u2019re getting a lot of requests right now. Your design is still here \u2014 please try again in a minute.', {
            label: 'Try again',
            onClick: function () { szrlNote(null); var cb = szmcIsCustomilyForm(f) && szmcCustomilyBtn(f); if (cb) { try { cb.click(); return; } catch (eC) {} } szmcAddForm(f, nativeSubmit); }
          });
          return;
        }
        var wait = Math.max(SZRL_STEPS[tries], Math.min(ra, 90)) * 1000; tries++;
        szrlSet(wait);
        szrlWait(f, wait, 'Too many requests, retrying in ', send);
      };
      var handle = function (r) {
        if (r && (r.status === 429 || r.status === 503)) { onRateLimit(r); return; }
        if (r && r.ok === false) { szrlNote(null); fallback(); return; }
        szrlNote(null);
        var done = function () { afterExternalAdd(); open('atc'); };
        return r.json().then(function (j) {
          var html = j && j.sections && j.sections[SECTION];
          if (!html || !el.dw) { fetchSection(done); return; }
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var inner = tmp.querySelector('#shopify-section-' + SECTION) || tmp.querySelector('[id^="shopify-section"]');
          var out = inner ? inner.innerHTML : html;
          ss(CACHE_HTML, out); el.dw.innerHTML = out; syncFromDom(); szmcPendInject();
          szmcFresh = Date.now(); done();
        }, function () { fetchSection(done); });
      };
      var send = function () {
        szmcPend.inflight = Date.now();
        pfetch('/cart/add.js', opt).then(handle).catch(function () { szrlNote(null); fallback(); });
      };
      /* đang trong thời gian chờ của lần 429 trước (cùng tab) -> chờ nốt rồi mới gửi, không bắn thêm vào xô rate-limit */
      var cd = szrlUntil() - Date.now();
      if (cd > 500) szrlWait(f, cd, 'Too many requests, adding in ', send);
      else send();
    }

    /* ---- R2-2 helpers (rate-limit /cart/add) — AI Agent làm theo chỉ thị của anh Hoá — 2026-10-31 04:20 VN — WEB-20261031-customio-r26-atc429 ---- */
    var SZRL_KEY = 'sz_rl_until', SZRL_STEPS = [10, 20, 40];
    function szrlUntil() { try { return +sessionStorage.getItem(SZRL_KEY) || 0; } catch (e) { return 0; } }
    function szrlSet(ms) { try { sessionStorage.setItem(SZRL_KEY, String(Date.now() + ms)); } catch (e) {} }
    function szrlWait(f, ms, label, cb) {              /* đếm ngược trên toast; khách bấm lại trong lúc chờ -> lần bấm mới thay lần cũ */
      if (f.__szRL) clearInterval(f.__szRL);
      var end = Date.now() + ms;
      var tick = function () {
        var s = Math.ceil((end - Date.now()) / 1000);
        if (s <= 0) { clearInterval(f.__szRL); f.__szRL = 0; szrlNote('Adding to cart\u2026'); cb(); return; }
        szrlNote(label + s + 's\u2026');
      };
      f.__szRL = setInterval(tick, 1000); tick();
    }
    function szrlNote(text, btn) {
      var n = document.getElementById('sz-rl-note');
      if (text === null) { if (n) n.remove(); return; }
      if (!n) {
        n = document.createElement('div'); n.id = 'sz-rl-note';
        n.setAttribute('role', 'status'); n.setAttribute('aria-live', 'polite');
        n.style.cssText = 'position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:2147483646;' +
          'width:max-content;max-width:min(92vw,420px);background:#1f2937;color:#fff;font:500 14px/1.4 system-ui,-apple-system,sans-serif;' +
          'padding:12px 16px;border-radius:10px;box-shadow:0 6px 24px rgba(0,0,0,.25);display:flex;gap:12px;align-items:center';
        document.body.appendChild(n);
      }
      n.textContent = '';
      var s = document.createElement('span'); s.style.cssText = 'flex:1 1 auto;min-width:0'; s.textContent = text; n.appendChild(s);
      if (btn) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = btn.label;
        b.style.cssText = 'flex:0 0 auto;width:auto;margin:0;white-space:nowrap;background:#fff;color:#111;border:0;border-radius:6px;padding:8px 14px;font:600 14px/1.2 system-ui,-apple-system,sans-serif;letter-spacing:0;text-transform:none;cursor:pointer;min-height:36px';
        b.addEventListener('click', btn.onClick); n.appendChild(b);
      }
    }
    function szrlBtnsIdle() {                          /* trả nút ATC về bình thường — KHÔNG đóng modal Customily (khác afterExternalAdd) */
      try {
        [].forEach.call(document.querySelectorAll('#customily-cart-btn,#customily-cart-btn-preview,.customily-preview-button,.add_to_cart'), function (b) {
          b.classList.remove('running', 'loading', 'is-loading', 'disabled'); b.disabled = false;
          if (/adding/i.test(b.textContent || '') && b.getAttribute('data-szmc-label')) b.innerHTML = b.getAttribute('data-szmc-label');
        });
      } catch (e) {}
    }

    /* ===== WEB-20260925-sz-customily-enter (P0: mất file Customily khi khách nhấn ENTER) =====
       AI Agent làm theo chỉ thị anh Hoá. Đo trên trang thật (draft 188552937775):
       - Nút thật khách bấm trên SP Customily = #customily-cart-btn (button[name=add], type=BUTTON)
         -> Customily chặn click, tạo production file/preview, rồi TỰ gọi form.submit()
         (wrapper prototype r5 lo phần add + mở drawer) => line item CÓ _customily-production-url.
       - Nút native theme (button[name=add] type=submit) bị Customily ẩn (class hidden-customily…).
       - window.Customily tồn tại; form CHƯA có field _customily-* cho tới khi Customily chạy xong.
       VÌ SAO lỗi: khách gõ tên rồi nhấn ENTER -> phát sự kiện 'submit' NATIVE -> handler dưới
       thêm hàng NGAY bằng szmcAddForm (TRƯỚC khi Customily kịp tạo file) => đơn thiếu
       _customily-production-url/_customily-preview (đơn #334984, #335116, #335135, #335271, #335397).
       FIX: sự kiện 'submit' trên form Customily mà CHƯA sẵn sàng => KHÔNG tự add, mà bấm đúng
       #customily-cart-btn để Customily chạy flow (nó dùng form.submit(), KHÔNG phát 'submit' nên
       không lặp; nút type=button nên click cũng không tái phát 'submit'). SP thường: giữ nguyên. */
    function szmcCustomilyBtn(f) {
      return f.querySelector('#customily-cart-btn, button[name="add"].add_to_cart:not([type="submit"]), .customily-preview-button');
    }
    function szmcIsCustomilyForm(f) {
      /* 25/09 v2 (WEB-20260925-sz-customily-enter): CHI coi la SP Customily khi co NUT Add to Cart
         that cua Customily. Bo [class*="customily"] + window.Customily vi theme gan class
         'eb-modal-reselect-properties-customily' / 'sticky-customily-preview-button' vao ca SP
         Customall/SP thuong -> nhan nham -> chan add giỏ binh thuong. */
      try {
        if (f.querySelector('#customily-cart-btn, #customily-cart-btn-preview')) return true;
        if (document.querySelector('#customily-cart-btn')) return true;
      } catch (e) {}
      return false;
    }
    function szmcCustomilyReady(f) {                    // Customily đã tạo file xong -> add trực tiếp OK
      var el = f.querySelector('[name="properties[_customily-production-url]"]');
      return !!(el && String(el.value || '').trim());
    }
    function szmcTriggerCustomilyAdd(f) {
      if (f.__szmcCustAt && Date.now() - f.__szmcCustAt < 4000) return;   // chống lặp: 1 lần/4s
      f.__szmcCustAt = Date.now();
      var btn = szmcCustomilyBtn(f);
      if (btn) { try { btn.click(); return; } catch (e) {} }
      /* không thấy nút Customily -> để form native chạy (an toàn hơn là nuốt mất submit) */
      try { if (HTMLFormElement.prototype.__szmcNativeSubmit) { f.__szmcNative = 1; HTMLFormElement.prototype.__szmcNativeSubmit.call(f); } } catch (e) {}
    }

    /* --- ATC: chặn submit form + bọc fetch/XHR --- */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
      /* WEB-20260925: form Customily nhấn ENTER quá sớm -> lái qua nút Customily, KHÔNG tự add */
      if (!f.__szmcNative && szmcIsCustomilyForm(f) && !szmcCustomilyReady(f)) {
        e.preventDefault(); e.stopPropagation();
        szmcTriggerCustomilyAdd(f);
        return;
      }
      e.preventDefault(); e.stopPropagation();
      szmcAddForm(f);
    }, true);

    /* ===== r5 (2026-09-15 ~04:2x VN, WEB-20260915-suzitee-minicart-r5) =====
       AI Agent làm theo chỉ thị của anh Hoá.
       Đã làm: bọc HTMLFormElement.prototype.submit cho form /cart/add.

       VÌ SAO (đo được, không đoán — r5 lần đầu lái được luồng Customily THẬT bằng máy):
       Bấm ADD TO CART trong popup Preview của Customily -> app gọi **form.submit() bằng code**.
       `form.submit()` KHÔNG phát sự kiện 'submit' (chuẩn HTML) => handler ở trên KHÔNG BAO GIỜ chạy
       => trình duyệt POST thường /cart/add => nhảy sang trang /cart. Đây chính là P0 4 vòng chưa bắt được;
       log chứng minh: "SZDBG form.submit() called .../cart/add" ngay trước "beforeunload".

       Khác gì bản r2b (bản từng làm kẹt nút "ADDING TO CART…"): r2b nuốt submit rồi KHÔNG dọn trạng
       thái của app. Nay sau khi add xong luôn gọi afterExternalAdd() (trả chữ nút, mở khoá, đóng modal
       Customily) rồi mới mở drawer; add hỏng thì TRẢ LẠI submit gốc để khách không bao giờ kẹt. */
    if (!HTMLFormElement.prototype.__szmcSubmitWrapped) {
      var _nativeSubmit = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.__szmcNativeSubmit = _nativeSubmit;
      HTMLFormElement.prototype.submit = function () {
        try {
          if (this.action && /\/cart\/add/.test(this.action) && !this.__szmcNative) {
            szmcAddForm(this, _nativeSubmit);
            return;
          }
        } catch (e) {}
        return _nativeSubmit.apply(this, arguments);
      };
      HTMLFormElement.prototype.__szmcSubmitWrapped = 1;
    }

    /* r2b (lỗi 3 anh báo 01:54): Customily sau khi khách bấm xong preview thì tự submit form
       (không phải nút ATC thường) rồi ĐIỀU HƯỚNG sang /cart. Chặn 2 lớp:
       (a) form.submit() gọi bằng code — override prototype (sự kiện 'submit' KHÔNG bắt được ca này);
       (b) nếu vẫn lọt sang /cart: đánh dấu phiên rồi quay lại đúng trang cũ và bật drawer. */
    /* r2c (P0 anh báo 02:08): KHÔNG cướp form.submit() của Customily nữa — bản r2b nuốt mất luồng
       hoàn tất của app nên nút kẹt "ADDING TO CART...". Nay CHỈ QUAN SÁT: để request của Customily
       chạy trọn vẹn, xong mới (a) trả nút về chữ cũ, (b) đóng modal của Customily, (c) mở drawer ĐÈ LÊN. */
    /* r3: KHÔNG tin vào việc bọc fetch/XHR nữa — app khác (Customily/theme) cũng bọc và giữ bản gốc,
       nên móc của mình có thể bị bỏ qua. PerformanceObserver nhìn thấy MỌI request thật. */
    window.__szmcSelf = 0;                              // đánh dấu request do chính drawer gọi
    function externalAdd(url) {
      if (/\/cart\/add/.test(url || '')) lastExtAdd = Date.now();             // r4: app ngoai vua add
      if (window.__szmcSelf && Date.now() - window.__szmcSelf < 1500) return;  // của mình -> bỏ qua
      if (externalAdd.last && Date.now() - externalAdd.last < 1200) return;    // chống gọi trùng
      externalAdd.last = Date.now();
      setTimeout(function () {
        fetchSection(function () { if (/\/cart\/add/.test(url)) { afterExternalAdd(); open('atc'); } });
      }, 250);
    }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-31 04:20 VN — WEB-20261031-customio-r26-atc429 — Đã làm (chỉ có tác dụng khi có snippet sz-cart-attr-dedupe; Customio KHÔNG có POST update.js lúc load nên chưa cài snippet → dòng này no-op): POST /cart/update.js CHỈ attributes (pixel app ghi fbp/fbc) không đổi dòng hàng -> không nạp lại giỏ */
          if (/\/cart\/update/.test(e.name || '') && Date.now() - (window.__szAttrOnlyAt || 0) < 5000) return;
          if (/\/cart\/(add|change|update|clear)/.test(e.name || '')) externalAdd(e.name);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string' ? input : (input && input.url)) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/update/.test(url) && window.__szAttrOnly && window.__szAttrOnly(url, init)) return p;   /* R2-2: attributes-only -> không nạp lại giỏ */
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(function () { fetchSection(function () { if (/add/.test(url)) { afterExternalAdd(); open('atc'); } }); }, 250); }).catch(function () {});
      }
      return p;
    };
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__szmcUrl = u || ''; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      this.addEventListener('load', function () {
        if (/\/cart\/(add|change|update|clear)/.test(self.__szmcUrl || '')) {
          setTimeout(function () { fetchSection(function () { if (/add/.test(self.__szmcUrl)) { afterExternalAdd(); open('atc'); } }); }, 250);
        }
      });
      return _send.apply(this, arguments);
    };
  }

  /* ---------- r4: TRANG /cart — o so luong bam nhanh + tieu de modal xoa ----------
     (loi 4 + loi 6 anh bao 02:46). Tren /cart theme tu xu ly nut +/- bang 1 request moi lan bam,
     khoa nut cho den khi co dap. r4 bat o pha CAPTURE tren document, chan handler cua theme,
     cong so NGAY roi debounce 400ms moi goi mot /cart/change duy nhat. */
  function cpMoney(c) {
    return money(c);   /* r5-usd: một nguồn format DUY NHẤT, không còn toLocaleString (tránh "US$") */
  }
  function cpWire() {
    if (!isCartPage() || document.documentElement.__szmcCartPage) return;
    document.documentElement.__szmcCartPage = 1;
    var want = {}, timer = {}, lock = {};
    function spin(item, on) {
      var box = item && item.querySelector('.product-quantity-box'); if (!box) return;
      if (on) {
        item.classList.add('szmc-qty-wait');
        if (!box.querySelector('.szmc-qty-spin')) { var sp = document.createElement('span'); sp.className = 'szmc-qty-spin'; box.appendChild(sp); }
      } else {
        item.classList.remove('szmc-qty-wait');
        var o = box.querySelector('.szmc-qty-spin'); if (o) o.remove();
      }
    }
    function totals(c) {
      try {
        [].forEach.call(document.querySelectorAll('.js-sz-mdock-price'), function (n) { n.textContent = cpMoney(c.total_price || 0); });
        /* r12: tren DESKTOP Subtotal cua trang /cart nam o .js-cart_subtotal .money — handler capture
           cua minicart chan handler cua theme nen phai tu son lai, neu khong so nay se cu (stale)
           va MutationObserver cua cart-template con chep nguoc so cu do vao dock. */
        [].forEach.call(document.querySelectorAll('.js-cart_subtotal .money'), function (n) { n.textContent = cpMoney(c.total_price || 0); });
        szmcCurFix();                                     // r4b: dung 1 chu USD
        /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 18:30 VN — WEB-20260915-suzitee-cart-title-count
           Đã làm: thay vòng lặp chỉ sơn .cart_count bằng szmcPaintHeader(item_count) — cùng painter với
           drawer, nên trang /cart cập nhật đủ: badge desktop, badge mobile VÀ dòng "N items in your cart:". */
        szmcPaintHeader(c.item_count || 0);
      } catch (e) {}
    }
    function flush(line, item) {
      var q = want[line]; if (q == null) return;
      delete want[line]; lock[line] = 1; spin(item, true);
      pfetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: q })
      }).then(function (r) { return r.json(); })
        .then(function (c) {
          var it = (c.items || [])[line - 1];
          if (it) {
            var inp = item.querySelector('input.quantity'); if (inp) inp.value = it.quantity;
            var lp = item.querySelector('[data-line-price], .cart__item--price .money');
            if (lp) lp.textContent = cpMoney(it.final_line_price != null ? it.final_line_price : it.line_price);
          }
          totals(c);
        }).catch(function () {})
        .then(function () { lock[line] = 0; spin(item, false); if (want[line] != null) flush(line, item); });
    }
    document.addEventListener('click', function (e) {
      var qb = e.target && e.target.closest && e.target.closest('.js-change-quantity');
      if (!qb) return;
      if (el.dw && el.dw.contains(qb)) return;             // trong drawer -> handler rieng lo
      var item = qb.closest('.cart__item'); if (!item) return;
      var line = parseInt(item.getAttribute('data-line-id'), 10); if (!line) return;
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var inp = item.querySelector('input.quantity');
      var base = want[line] != null ? want[line] : parseInt((inp && inp.value) || '1', 10);
      var next = qb.getAttribute('data-func') === 'plus' ? base + 1 : base - 1;
      if (next < 1) next = 1;
      if (next === base) return;
      want[line] = next; if (inp) inp.value = next;        // so doi NGAY, nut khong khoa
      if (timer[line]) clearTimeout(timer[line]);
      timer[line] = setTimeout(function () { timer[line] = 0; if (!lock[line]) flush(line, item); }, 400);
    }, true);
    /* tieu de modal xoa cua trang /cart -> 1 dong, dung chu nhu Almagems */
    var tries = 0, iv = setInterval(function () {
      var t = document.querySelector('#cart-remove-confirm .eb-title-modal-confirm');
      if (t) { t.textContent = 'Are you sure to remove this item?'; clearInterval(iv); }
      if (++tries > 60) clearInterval(iv);
    }, 200);
  }

  /* ---------- cuộn lên + vòng tiến độ ---------- */
  function toTop() {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    setTimeout(function () { if ((window.pageYOffset || 0) > 4) window.scrollTo(0, 0); }, 700);
  }
  function onScroll() {
    if (!state.built) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var max = Math.max(1, (document.documentElement.scrollHeight || 0) - window.innerHeight);
    var pct = Math.min(1, Math.max(0, y / max));
    if (el.ring && RING_C) el.ring.style.strokeDashoffset = (RING_C * (1 - pct)).toFixed(1);
    el.top.classList.toggle('is-on', y > 320);
    lift();
  }
  // nâng cụm nút khi có thanh CTA dính đáy (PDP) để không bị đè
  function lift() {
    var bar = document.querySelector('.sticky-checkout-section:not([style*="display: none"]), .sticky-add-to-cart, #sticky-atc');
    var h = 0;
    if (bar) { var r = bar.getBoundingClientRect(); if (r.height && r.bottom > window.innerHeight - 4) h = Math.round(r.height); }
    document.documentElement.style.setProperty('--szmc-lift', h + 'px');
  }

  /* ---------- khởi động ---------- */
  function boot() {
    build();
    // (b) lọt sang /cart sau khi Customily thêm hàng -> quay lại trang cũ và bật drawer
    try {
      var back = ss('szmc:back');
      var backAt = parseInt(ss('szmc:backAt') || '0', 10);
      if (backAt && Date.now() - backAt > 25000) { back = ''; ss('szmc:back', ''); }  // r4: chi cuu trong 25s
      /* r5 (2026-09-15 ~04:5x VN) — AI Agent làm theo chỉ thị anh Hoá.
         Đã BỎ lưới "tự quay về trang cũ" của r4. Vì sao: r4 phải bounce vì Customily điều hướng sang
         /cart; r5 đã CHẶN TẬN GỐC (bọc HTMLFormElement.prototype.submit) nên không còn gì để cứu —
         mà giữ lại thì HẠI THẬT: QC r5 bắt được cảnh khách bấm ATC xong **tự bấm vào giỏ** trong 25s
         liền bị đá NGƯỢC về trang sản phẩm (regress-390: mở /cart lại ra title trang sản phẩm).
         Nay: vào /cart là ở lại /cart. `szmc:back` chỉ còn để dọn, không điều hướng nữa. */
      if (isCartPage() && back) ss('szmc:back', '');
      if (sessionStorage.getItem('szmc:autoopen') === '1') {
        sessionStorage.removeItem('szmc:autoopen');
        setTimeout(function () { open('customily-back'); }, 60);
      }
    } catch (e) {}
    // nạp sẵn (lệnh tốc độ 01:27): có hàng -> có HTML trong cache trước khi anh bấm
    pfetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        ss(CACHE_CART, JSON.stringify(c));
        setCount(c.item_count || 0);
        /* WEB-20261018-suzitee-cart-addon-order: trang /cart xoá SP chính bằng link /cart/change?quantity=0 (tải lại trang)
           -> tới đây dọn add-on mồ côi cùng khoá rồi tải lại 1 lần (chặn vòng lặp 15s). Trang khác: chỉ nạp lại section. */
        if (szmcAddonOrphans(c).length) {
          szmcSweepAddons(c, function (c2) {
            if (!c2) return;
            setCount(c2.item_count || 0);
            if (isCartPage()) {
              var lr = +(ss('szmc:aosweep') || 0);
              if (Date.now() - lr > 15000) { ss('szmc:aosweep', String(Date.now())); location.reload(); }
            } else if (c2.item_count > 0) fetchSection();
          });
          return;
        }
        if (c.item_count > 0) fetchSection();
      }).catch(function () {});
    cpWire();                                            // r4: trang /cart
    szmcCurWatch();                                      // r4b: chuan hoa duoi ma tien te
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', lift);
    onScroll();
  }

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 15:55 VN — WEB-20260915-suzitee-mobile-qty-inert
     Đã làm: chặn ô số lượng nhận focus trên MOBILE (<1024px). Trước: chạm số -> caret + bàn phím iOS.
     Sau: chạm số không làm gì (CSS pointer-events:none lo phần chạm; đoạn này là lưới an toàn cho
     focus lập trình/Tab và cho các dòng giỏ được render lại sau AJAX — không cần MutationObserver).
     Nút +/- (.js-change-quantity) KHÔNG đụng tới. Desktop >=1024px: gỡ readonly, gõ tay như cũ. */
  var SZMC_QTY_MQ = null;
  try { SZMC_QTY_MQ = window.matchMedia('(max-width:1023px)'); } catch (e) {}
  function szmcQtyMobile() { return !!(SZMC_QTY_MQ && SZMC_QTY_MQ.matches); }
  function szmcQtyMark(inp) {
    if (!inp) return;
    if (szmcQtyMobile()) {
      inp.setAttribute('readonly', 'readonly');
      inp.setAttribute('inputmode', 'none');
      inp.setAttribute('tabindex', '-1');
      inp.setAttribute('aria-readonly', 'true');
    } else if (inp.hasAttribute('readonly')) {
      inp.removeAttribute('readonly');
      inp.removeAttribute('inputmode');
      inp.removeAttribute('tabindex');
      inp.removeAttribute('aria-readonly');
    }
  }
  function szmcQtySweep() {
    try {
      var l = document.querySelectorAll('.cart__item input.quantity');
      for (var i = 0; i < l.length; i++) szmcQtyMark(l[i]);
    } catch (e) {}
  }
  document.addEventListener('focusin', function (e) {
    try {
      if (!szmcQtyMobile()) return;
      var t = e.target;
      if (!t || !t.matches || !t.matches('input.quantity')) return;
      if (!t.closest('.cart__item')) return;
      szmcQtyMark(t);
      t.blur();                                   // không giữ focus -> iOS không mở bàn phím
    } catch (err) {}
  }, true);
  if (SZMC_QTY_MQ) {
    var szmcQtyOnMQ = function () { szmcQtySweep(); };
    if (SZMC_QTY_MQ.addEventListener) SZMC_QTY_MQ.addEventListener('change', szmcQtyOnMQ);
    else if (SZMC_QTY_MQ.addListener) SZMC_QTY_MQ.addListener(szmcQtyOnMQ);
  }
  document.addEventListener('click', function () { setTimeout(szmcQtySweep, 60); }, true);
  setInterval(szmcQtySweep, 1500);                // rẻ: querySelectorAll vài phần tử, không đụng layout
  szmcQtySweep();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();


  /* ===== r6 (2026-10-08 VN, WEB-20261008-cart-preview-almagems) — AI Agent làm theo chỉ thị anh Hoá =====
     Đã làm: bấm ADD TO CART trên SP Customily -> Customily mất ~5-7s lưu ảnh rồi mới gọi /cart/add.
     Trước: suốt 5-7s đó drawer CHƯA mở (khách tưởng nút chết). Nay: 300ms sau cú bấm, nếu nút Customily
     đang chạy (class running / "ADDING…" / disabled) -> mở drawer NGAY với ô "Adding your personalized
     item…" (khung cao cố định như 1 dòng hàng). /cart/add xong -> open('atc') gỡ ô chờ, nội dung thật vào.
     KHÔNG tự add, KHÔNG gửi request nào -> không thể tạo add trùng/thiếu properties (luồng add giữ nguyên
     szmcAddForm + sz-atc-lock). Customily dừng mà không add, hoặc quá 30s -> báo lỗi 3.5s rồi gỡ (drawer
     mở chỉ vì ô chờ và giỏ rỗng thì đóng lại). */
  var szmcPend = { on: false, t: 0, err: '', byUs: false, timer: 0, chk: 0, inflight: 0, btn: null, info: null, po: null };
  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 03:00 VN — WEB-20261009-suzitee-customily-atc-r10
     Đã làm (r10, rút ngắn cảm nhận ~6s chờ Customily lưu ảnh):
     1. Ô chờ trong giỏ nay là MỘT DÒNG HÀNG ĐỦ (ảnh thiết kế khách vừa làm chụp từ canvas Customily trên trang,
        thu 160px JPEG; tên SP, biến thể, các lựa chọn khách điền, giá) + dòng nhỏ "Saving your design…".
        Chỉ HIỂN THỊ — không gửi request, không đổi form -> không thể trùng dòng/thiếu properties.
        Canvas bị taint/không có -> dùng ảnh SP đang hiện; không có gì -> spinner như cũ.
     2. preconnect s3.us-west-1.amazonaws.com + app.customily.com (+ sh/cdn) ngay khi khách bắt đầu điền form
        Customily / chạm nút ADD -> bớt bắt tay TLS lạnh (~0,4-0,6s đo được ở lượt upload S3 đầu tiên).
     3. Trong lúc chờ: nghe PerformanceObserver('resource') — Customily HEAD ảnh thumb trên CDN (~2,9s) là
        mình nạp sẵn ảnh đó -> lúc dòng thật hiện thì ảnh đã ở cache. Observer chỉ sống trong lúc chờ. */
  var szmcFresh = 0, szmcPcDone = 0;
  function szmcPrefetchImg(u) {
    try { if (!u || szmcPrefetchImg[u]) return; szmcPrefetchImg[u] = 1; var im = new Image(); im.decoding = 'async'; try { im.fetchPriority = 'high'; } catch (e) {} im.src = u; } catch (e) {}
  }
  function szmcPreconnect() {
    if (Date.now() - szmcPcDone < 8000) return; szmcPcDone = Date.now();
    try {
      ['https://s3.us-west-1.amazonaws.com', 'https://app.customily.com', 'https://sh.customily.com', 'https://cdn.customily.com'].forEach(function (h) {
        var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; l.crossOrigin = 'anonymous';
        document.head.appendChild(l); setTimeout(function () { try { l.remove(); } catch (e) {} }, 9000);
      });
    } catch (e) {}
  }
  function szmcGrabInfo(btn) {
    var info = { img: '', title: '', variant: '', props: [], price: '' };
    try {
      var f = (btn && btn.closest && btn.closest('form')) || document.querySelector('form[action*="/cart/add"]');
      var root = (f && f.closest('.product, .product-section, .product_section, [class*="product-template"], main')) || document;
      var cv = null, best = 0;
      [].forEach.call(document.querySelectorAll('canvas'), function (c) {
        var r = c.getBoundingClientRect(); var a = r.width * r.height;
        if (a > best && r.width > 120 && c.width > 120 && !c.closest('.szmc-dw')) { best = a; cv = c; }
      });
      if (cv) {
        try {
          var k = Math.min(1, 160 / Math.max(cv.width, cv.height)), t = document.createElement('canvas');
          t.width = Math.round(cv.width * k); t.height = Math.round(cv.height * k);
          var x = t.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, t.width, t.height); x.drawImage(cv, 0, 0, t.width, t.height);
          info.img = t.toDataURL('image/jpeg', 0.8);
        } catch (e) { info.img = ''; }
      }
      if (!info.img) {
        var im = [].filter.call(root.querySelectorAll('img'), function (i) { var r = i.getBoundingClientRect(); return r.width > 150 && i.complete && i.naturalWidth > 0 && r.bottom > 0; })[0];
        if (im) info.img = im.currentSrc || im.src;
      }
      var h = root.querySelector('h1') || document.querySelector('h1'); info.title = h ? h.innerText.trim() : '';
      if (f) {
        var v = [];
        [].forEach.call(f.querySelectorAll('select[name^="option"], input[name^="option"]:checked, select[data-index], .single-option-selector'), function (o) { if (o.value && !/^\d{5,}$/.test(o.value) && v.indexOf(o.value) < 0) v.push(o.value); });
        info.variant = v.join(' / ');
        var seen = {};
        [].forEach.call(f.elements, function (e) {
          var m = /^properties\[([^\]]+)\]$/.exec(e.name || ''); if (!m || m[1].charAt(0) === '_' || seen[m[1]]) return;
          if ((e.type === 'radio' || e.type === 'checkbox') && !e.checked) return;
          if (e.type === 'file' || !e.value) return; seen[m[1]] = 1;
          info.props.push([m[1], String(e.value).slice(0, 60)]);
        });
      }
      var pr = [].filter.call(root.querySelectorAll('[class*="price"]'), function (p) { var r = p.getBoundingClientRect(); return r.height > 0 && /\$\s?\d/.test(p.innerText) && !/compare|was/i.test(p.className); })[0];
      if (pr) { var mm = /\$\s?[\d.,]+/.exec(pr.innerText); info.price = mm ? mm[0] : ''; }
    } catch (e) {}
    return (info.img || info.title) ? info : null;
  }
  function szmcEsc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  document.addEventListener('focusin', function (e) { try { if ((window.customily || window.Customily || window.customilyShopify) && e.target.closest && e.target.closest('form[action*="/cart/add"]')) szmcPreconnect(); } catch (err) {} }, true);
  document.addEventListener('pointerdown', function (e) { try { if (e.target.closest && e.target.closest('#customily-cart-btn, #customily-cart-btn-preview, form[action*="/cart/add"]') && (window.customily || window.Customily || window.customilyShopify)) szmcPreconnect(); } catch (err) {} }, true);
  function szmcBtnBusy(b) {
    if (!b) return false;
    return b.classList.contains('running') || b.classList.contains('loading') || b.disabled ||
      /adding/i.test(b.innerText || '');
  }
  function szmcPendInject() {
    try {
      if (!szmcPend.on || !el.dw) return;
      var body = el.dw.querySelector('.szmc-dw__body');
      if (!body) { body = document.createElement('div'); body.className = 'szmc-dw__body'; el.dw.appendChild(body); }
      var old = body.querySelector('.szmc-pend'); if (old) old.remove();
      var d = document.createElement('div');
      d.className = 'szmc-pend' + (szmcPend.err ? ' is-err' : '');
      d.setAttribute('role', 'status'); d.setAttribute('aria-live', 'polite');
      var I = szmcPend.info;
      if (!szmcPend.err && I) {
        d.className += ' is-rich';
        d.innerHTML = '<span class="szmc-pend__img">' + (I.img ? '<img alt="" src="' + szmcEsc(I.img) + '">' : '<span class="szmc-pend__spin"></span>') + '</span>' +
          '<div class="szmc-pend__txt"><b class="szmc-pend__t">' + szmcEsc(I.title) + '</b>' +
          (I.variant ? '<small>' + szmcEsc(I.variant) + '</small>' : '') +
          I.props.map(function (p) { return '<small><span>' + szmcEsc(p[0]) + ':</span> ' + szmcEsc(p[1]) + '</small>'; }).join('') +
          (I.price ? '<strong class="szmc-pend__price">' + szmcEsc(I.price) + '</strong>' : '') +
          '<em class="szmc-pend__save"><span class="szmc-pend__spin"></span>Saving your design\u2026</em></div>';
      } else
      d.innerHTML = szmcPend.err
        ? '<div class="szmc-pend__txt"><b>' + szmcPend.err + '</b></div>'
        : '<span class="szmc-pend__img"><span class="szmc-pend__spin"></span></span><div class="szmc-pend__txt"><b>Adding your personalized item\u2026</b><small>Saving your design \u2014 just a few seconds.</small><i></i><i></i></div>';
      body.insertBefore(d, body.firstChild);
      var empty = body.querySelector('.szmc-dw__empty'); if (empty) empty.style.display = 'none';
    } catch (e) {}
  }
  function szmcPendEnd() {
    if (!szmcPend.on) return;
    szmcPend.on = false; szmcPend.err = ''; szmcPend.info = null;
    try { if (szmcPend.po) szmcPend.po.disconnect(); } catch (e) {} szmcPend.po = null;
    clearTimeout(szmcPend.timer); clearInterval(szmcPend.chk);
    try { [].forEach.call(el.dw.querySelectorAll('.szmc-pend'), function (x) { x.remove(); }); } catch (e) {}
    try { var em = el.dw.querySelector('.szmc-dw__empty'); if (em) em.style.display = ''; } catch (e) {}
  }
  function szmcPendFail(msg) {
    if (!szmcPend.on || szmcPend.err) return;
    szmcPend.err = msg; clearInterval(szmcPend.chk); clearTimeout(szmcPend.timer);
    szmcPendInject();
    setTimeout(function () {
      var by = szmcPend.byUs; szmcPendEnd();
      if (by && !(state.count > 0)) close();
    }, 3500);
  }
  function szmcPendStart(btn) {
    if (szmcPend.on) return;
    szmcPend.on = true; szmcPend.err = ''; szmcPend.t = Date.now(); szmcPend.btn = btn;
    szmcPend.byUs = !state.open;
    szmcPend.info = szmcGrabInfo(btn);
    try {
      if (window.PerformanceObserver) {
        szmcPend.po = new PerformanceObserver(function (l) {
          l.getEntries().forEach(function (en) { if (/cdn\.customily\.com\/.*\/thumbs\//.test(en.name)) szmcPrefetchImg(en.name.split('#')[0]); });
        });
        szmcPend.po.observe({ type: 'resource' });
      }
    } catch (e) {}
    open('atc-pending');
    szmcPendInject();
    szmcPend.timer = setTimeout(function () { szmcPendFail("Sorry, we couldn't add this item. Please try again."); }, 30000);
    var idle = 0;
    szmcPend.chk = setInterval(function () {
      if (!szmcPend.on) { clearInterval(szmcPend.chk); return; }
      var addSince = (lastExtAdd > szmcPend.t) || (szmcPend.inflight > szmcPend.t);
      if (addSince || szmcBtnBusy(szmcPend.btn)) { idle = 0; return; }
      idle += 1;
      if (idle >= 5 && Date.now() - szmcPend.t > 2000) szmcPendFail("Sorry, we couldn't add this item. Please try again.");
    }, 400);
  }
  function szmcWarmPreview() {
    /* Almagems: ảnh trong giỏ CHÍNH LÀ ảnh preview nên bấm Preview là có ngay. Mình hiện thumb nhẹ ->
       nạp sẵn ảnh preview lớn của dòng đầu lúc rảnh để bấm Preview không phải chờ. */
    setTimeout(function () {
      try {
        var items = JSON.parse((el.dw.querySelector('[data-szmc-cart]') || {}).textContent || '[]');
        var n = 0;                                   /* dòng đầu có thể là Extra Protection -> lấy 2 dòng ĐẦU TIÊN có preview */
        for (var i = 0; i < items.length && n < 2; i++) {
          var p = (items[i] && items[i].properties) || {};
          var u = p['_customily-preview'] || p['_customall_preview'];
          if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; n++; }
        }
      } catch (e) {}
    }, 1200);
  }
  document.addEventListener('click', function (e) {
    try {
      var b = e.target && e.target.closest && e.target.closest('#customily-cart-btn, #customily-cart-btn-preview');
      if (!b || isCartPage()) return;
      if (szAtcMode() === 'wait') return;           /* r9: chế độ wait do szAtcWaitClick lo (không mở drawer chờ) */
      setTimeout(function () { if (szmcBtnBusy(b)) szmcPendStart(b); }, 300);
    } catch (err) {}
  }, true);
  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-08 VN — WEB-20261008-suzitee-checkout-speed
     Đã làm: bấm SECURE CHECKOUT / PROCEED TO CHECKOUT (nút submit name=checkout) không còn bị app
     Searchanise giữ lại. Searchanise gắn delegate 'click' lên ':submit[name="checkout"]': preventDefault
     -> $.getJSON('/cart.js') -> SendOrderStatistic -> trigger click lại => khách chờ thêm 1 vòng mạng
     (~300-450ms ở 4G/CPU4x) trước khi trình duyệt mới bắt đầu POST /cart -> /checkouts.
     Cách sửa: listener CAPTURE chạy trước delegate của Searchanise: gửi thống kê của Searchanise ngay
     bằng giỏ đã cache (sessionStorage szmc:cart:v2, cập nhật sau mỗi /cart.js & /cart/change.js) rồi gắn
     class 'se-processed' (cờ chính Searchanise dùng để "cho qua") => submit native đi thẳng.
     Không preventDefault, không đụng form/attributes/Extra Protection; pixel begin_checkout giữ nguyên.
     Không có Searchanise / không có cache => không làm gì (Searchanise tự chạy như cũ). */
  document.addEventListener('click', function (e) {
    try {
      var b = e.target && e.target.closest && e.target.closest('[type="submit"][name="checkout"], .eb-checkout-btn');
      if (!b || b.classList.contains('se-processed')) return;
      var S = window.Searchanise;
      if (!S || typeof S.SendOrderStatistic !== 'function') return;
      var c = null; try { c = JSON.parse(sessionStorage.getItem(CACHE_CART) || 'null'); } catch (x) {}
      if (!c || !c.items || !c.items.length) return;
      b.classList.add('se-processed');
      try { S.SendOrderStatistic(c, c.items, function () {}); } catch (x) {}
    } catch (err) {}
  }, true);

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-09 03:45 VN — WEB-20261009-suzitee-r12-merge
     Đã làm: gộp r10 (dòng tạm giàu + sections bundle) với r9 (công tắc atc_mode). wait: không hiện dòng tạm, nút giữ chữ + spinner tới khi giỏ đầy đủ; instant: dòng tạm r10. */
  /* ===== r9 (2026-10-09 VN, WEB-20261009-suzitee-atc-mode) — AI Agent làm theo chỉ thị của anh Hoá =====
     Đã làm: CÔNG TẮC theme setting "atc_mode" (Theme editor > Suzitee cart), áp cho nút ADD TO CART của SP cá nhân hoá
     (Customily #customily-cart-btn/-preview, Customall .btn-add-to-cart).
       - instant (mặc định) = y hành vi r6: drawer mở ngay với ô "Adding your personalized item…".
       - wait (kiểu Almagems) = KHÔNG mở drawer chờ; nút hiện spinner + disabled (aria-busy, chặn click lặp) tới khi
         /cart/add xong + section giỏ đã nạp (open('atc')) rồi drawer mở ĐẦY ĐỦ. 15s chưa xong -> gỡ spinner, nạp giỏ:
         có hàng thì mở drawer, không thì hiện dòng lỗi dưới nút (không treo). App không add (thiếu ô bắt buộc) -> gỡ spinner sớm.
       Không gửi request nào, không đụng luồng add -> không thể add trùng/thiếu properties.
     metrics.clickToFullMs = ms từ cú bấm tới lúc drawer đầy đủ (cả 2 chế độ). */
  function szAtcMode() { return window.__szAtcMode === 'wait' ? 'wait' : 'instant'; }
  var szW = { on: false, btn: null, t: 0, timer: 0, chk: 0 }, szClickT = 0;
  (function () {
    try {
      var st = document.createElement('style');
      /* spinner vẽ bằng 2 pseudo: ::after = lớp phủ cùng màu nền nút (che chữ — Customily chép style inline vào span.text nên không ép màu chữ được), ::before = vòng quay */
      /* r10: GIỮ chữ ADD TO CART (không phủ lớp che), spinner nhỏ bên phải trong nút */
      st.textContent = 'html body .sz-atcw{position:relative!important;pointer-events:none!important;cursor:progress!important;opacity:.92!important}' +
        'html body .sz-atcw::after{content:""!important;display:block!important;position:absolute!important;right:14px!important;top:50%!important;width:18px!important;height:18px!important;margin:-9px 0 0 0!important;z-index:4!important;border-radius:50%!important;' +
        'border:2.5px solid rgba(255,255,255,.45)!important;border-top-color:#fff!important;background:none!important;opacity:1!important;visibility:visible!important;box-sizing:border-box!important;animation:szatcw .7s linear infinite!important}' +
        'html body .sz-atcw::before{display:none!important;content:none!important}html body .sz-atcw{background-color:var(--sz-atcw-bg,#f4993d)!important;opacity:1!important}html body .sz-atcw .ld,html body .sz-atcw [class*=spin],html body .sz-atcw svg,html body .sz-atcw img,html body .sz-atcw i{display:none!important}html body .sz-atcw,html body .sz-atcw *{color:#fff!important;-webkit-text-fill-color:#fff!important}' +
        '@keyframes szatcw{from{transform:rotate(0)}to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){html body .sz-atcw::after{animation-duration:2s!important}}' +
        '.sz-atcw-err{font-size:13px;line-height:1.4;margin:8px 0 0;color:#b91c1c}';
      document.head.appendChild(st);
    } catch (e) {}
  })();
  function szAtcWaitEnd(ok) {
    if (szClickT && ok) { metrics.clickToFullMs = Date.now() - szClickT; szClickT = 0; }
    if (!szW.on) return;
    szW.on = false; clearTimeout(szW.timer); clearInterval(szW.chk);
    try { szW.btn.classList.remove('sz-atcw'); szW.btn.removeAttribute('aria-busy'); } catch (e) {}
    szW.btn = null;
  }
  function szAtcWaitErr(btn) {
    try {
      var p = btn.parentNode; if (!p || p.querySelector('.sz-atcw-err')) return;
      var n = document.createElement('p'); n.className = 'sz-atcw-err'; n.setAttribute('role', 'alert');
      n.textContent = "Sorry, this is taking longer than usual. Please try again.";
      p.insertBefore(n, btn.nextSibling); setTimeout(function () { n.remove(); }, 6000);
    } catch (e) {}
  }
  function szAtcCaInvalid() {
    try { return !!document.querySelector('.customall-wrapper .ant-form-item-explain-error, .customall-wrapper .ant-form-item-has-error, .sz-ca-miss'); } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    try {
      var b = e.target && e.target.closest && e.target.closest('#customily-cart-btn, #customily-cart-btn-preview, .btn-add-to-cart');
      if (!b || isCartPage()) return;
      /* r10: chỉ chặn cú bấm THẬT lặp lại; click giả (Customily popup tự click #customily-cart-btn sau khi lưu thiết kế) PHẢI đi qua, nếu không /cart/add không bao giờ chạy */
      if (szW.on) { if (e.isTrusted) { e.preventDefault(); e.stopImmediatePropagation(); } return; }
      if (!e.isTrusted) return;
      szClickT = Date.now();
      if (szAtcMode() !== 'wait') return;
      var c0 = state.count || 0, t0 = szClickT, idle = 0, isCA = b.classList.contains('btn-add-to-cart');
      szW.on = true; szW.btn = b; szW.t = t0;
      setTimeout(function () { if (szW.on && szW.btn === b) { try { b.style.setProperty('--sz-atcw-bg', getComputedStyle(b).backgroundColor); } catch (x) {} b.classList.add('sz-atcw'); b.setAttribute('aria-busy', 'true'); } }, 0);
      szW.timer = setTimeout(function () {
        if (!szW.on) return; var bb = szW.btn; szAtcWaitEnd(false);
        /* r10: so số lượng giỏ trước/sau bấm — add đã thành công thì vẫn mở giỏ; chưa thì báo lỗi, nút đã trả về bình thường */
        fetchSection(function () { if (state.count > c0) { afterExternalAdd(); open('atc'); } else szAtcWaitErr(bb); });
      }, 15000);
      szW.chk = setInterval(function () {
        if (!szW.on) return;
        var addSince = (lastExtAdd > t0) || (szmcPend.inflight > t0);
        if (addSince) { idle = 0; return; }
        if (isCA) { if (Date.now() - t0 > 600 && szAtcCaInvalid()) szAtcWaitEnd(false); return; }
        if (szmcBtnBusy(b)) { idle = 0; return; }
        idle += 1;
        if (idle >= 5 && Date.now() - t0 > 2000) szAtcWaitEnd(false);   /* Customily không chạy (thiếu ô) -> trả nút */
      }, 400);
    } catch (err) {}
  }, true);
  window.__szmc = { open: open, close: close, metrics: metrics, state: state, refresh: fetchSection };
})();


/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 22:55 VN — WEB-20261020-customio-cufix3-popup-fab
   Đã làm: nút nổi MY CART (.szmc-cart) + nút lên-đầu (.szmc-top) TỰ ẨN khi đang nằm chồng lên nút ADD TO CART trên trang
   (#customily-cart-btn / nút add của form SP), hiện lại khi ATC cuộn qua. Trước: iPhone 440, cuộn để ATC ngang đáy màn hình
   (~y 690–810) → MY CART (fixed right 14px, bottom 148px) đè đầu phải nút ATC. Chỉ đổi hiển thị, không đụng logic giỏ/Customily.
   Gỡ: xoá khối này. */
(function () {
  var SEL = '#customily-cart-btn, form[action*="/cart/add"] [name="add"]';
  var st = document.createElement('style');
  st.textContent = '.szmc-cart.szmc-atc-hide,.szmc-top.szmc-atc-hide{opacity:0!important;visibility:hidden!important;pointer-events:none!important;}';
  (document.head || document.documentElement).appendChild(st);
  var raf = 0;
  function check() {
    raf = 0;
    var fabs = document.querySelectorAll('.szmc-cart, .szmc-top');
    if (!fabs.length) return;
    var atcs = document.querySelectorAll(SEL), rs = [], i, j;
    for (i = 0; i < atcs.length; i++) {
      if (atcs[i].closest('.szmc-dw')) continue;
      var r = atcs[i].getBoundingClientRect();
      if (r.width > 20 && r.height > 10 && r.bottom > 0 && r.top < innerHeight) rs.push(r);
    }
    for (j = 0; j < fabs.length; j++) {
      var f = fabs[j].getBoundingClientRect(), on = false;
      if (f.width > 0) for (i = 0; i < rs.length; i++) {
        var a = rs[i];
        if (f.left < a.right + 6 && a.left - 6 < f.right && f.top < a.bottom + 6 && a.top - 6 < f.bottom) { on = true; break; }
      }
      fabs[j].classList.toggle('szmc-atc-hide', on);
    }
  }
  function q() { if (!raf) raf = requestAnimationFrame(check); }
  window.addEventListener('scroll', q, { passive: true });
  window.addEventListener('resize', q);
  setInterval(q, 700);
  q();
})();
